{
  "starters": {
    "rewards": [
      {
        "key": "homework",
        "name": "Zamanında ödev",
        "emoji": "✓"
      },
      {
        "key": "help",
        "name": "Yardımlaşma",
        "emoji": "🤝"
      },
      {
        "key": "cooperate",
        "name": "Grup çalışması",
        "emoji": "🌿"
      },
      {
        "key": "focus",
        "name": "Derse odaklanma",
        "emoji": "👀"
      },
      {
        "key": "raise-hand",
        "name": "Parmak kaldırma",
        "emoji": "✋"
      },
      {
        "key": "challenge",
        "name": "Görev tamam",
        "emoji": "⭐"
      }
    ],
    "reminders": [
      {
        "key": "chatting",
        "name": "İzinsiz konuşma",
        "emoji": "💬"
      },
      {
        "key": "materials",
        "name": "Eksik araç gereç",
        "emoji": "🎒"
      },
      {
        "key": "late-homework",
        "name": "Geciken ödev",
        "emoji": "📋"
      },
      {
        "key": "disturbing",
        "name": "Dikkati dağılma",
        "emoji": "🔔"
      }
    ],
    "homework": [
      {
        "key": "language-workbook",
        "name": "Okuma",
        "emoji": "📖"
      },
      {
        "key": "language-writing",
        "name": "Yazım",
        "emoji": "✏️"
      },
      {
        "key": "math-workbook",
        "name": "Matematik",
        "emoji": "🧮"
      },
      {
        "key": "contact-book",
        "name": "Ödev defteri",
        "emoji": "📝"
      }
    ],
    "daily": [
      {
        "key": "morning-reading",
        "name": "Sabah görevi",
        "emoji": "☀️"
      },
      {
        "key": "reading",
        "name": "20 dk kitap",
        "emoji": "📚"
      },
      {
        "key": "water",
        "name": "Suluk",
        "emoji": "💧"
      },
      {
        "key": "cleaning",
        "name": "Temiz sıra",
        "emoji": "🧹"
      },
      {
        "key": "materials",
        "name": "Çanta açma",
        "emoji": "🎒"
      }
    ],
    "store": [
      {
        "key": "sticker",
        "name": "Çıkartma",
        "emoji": "🌈",
        "points": 5
      },
      {
        "key": "library-first",
        "name": "İlk kitap seçimi",
        "emoji": "📚",
        "points": 8
      },
      {
        "key": "helper",
        "name": "Öğretmen yardımcısı",
        "emoji": "🤝",
        "points": 10
      },
      {
        "key": "seat",
        "name": "Sıra seçimi",
        "emoji": "🪑",
        "points": 15
      },
      {
        "key": "social-treat",
        "name": "Öğretmenle yemek",
        "emoji": "🍱",
        "points": 15
      },
      {
        "key": "homework-pass",
        "name": "Ödev muafiyeti",
        "emoji": "📝",
        "points": 20
      },
      {
        "key": "mystery",
        "name": "Sürpriz ödül",
        "emoji": "🎁",
        "points": 25
      },
      {
        "key": "top-prize",
        "name": "Öğretmen koltuğu",
        "emoji": "👑",
        "points": 30
      }
    ],
    "instructions": [
      {
        "key": "ready",
        "title": "Derse hazırlık",
        "steps": [
          "Kitap ve kaleminizi çıkarın",
          "Tahtadaki sayfayı açın",
          "Gözler bende olsun"
        ]
      },
      {
        "key": "group",
        "title": "Grup çalışması",
        "steps": [
          "Fikrinizi sırayla paylaşın",
          "Grubunuzun cevabını yazın",
          "Bir sözcü seçin"
        ]
      },
      {
        "key": "finished",
        "title": "Erken mi bitti?",
        "steps": [
          "Adınızın yazdığını kontrol edin",
          "Kağıdınızı teslim edin",
          "Sessizce kitap okuyun"
        ]
      },
      {
        "key": "pack-up",
        "title": "Toplanma vakti",
        "steps": [
          "Sıranızın üstünü toplayın",
          "Sandalyenizi itin ve çöpleri alın",
          "Sessizce sıraya geçin"
        ]
      }
    ],
    "phrases": [
      "Veli imzası lütfen",
      "Düzeltmeler yarına",
      "Formu geri getirin",
      "Suluk getirin",
      "Hırka getirin",
      "Beden için spor ayakkabı",
      "Yarın yazım testi var",
      "Kütüphane kitabı iadesi"
    ],
    "duties": [
      "Sıra başı",
      "Tahta silme",
      "Kağıt dağıt",
      "Geri dönüşüm",
      "Işıklar",
      "Kapı görevli"
    ]
  },
  "certificate": {
    "awards": [
      {
        "id": "star",
        "label": "Yıldız öğrenci",
        "title": "Yıldız Öğrenci",
        "phrases": [
          "Çalışkanlığın, nezaketin ve harika tutumunla her gün parladığın için.",
          "Tüm sınıfa harika bir örnek olduğun için.",
          "Elinden gelenin en iyisini yaptığın ve sınıfımızı aydınlattığın için."
        ],
        "suffix": ""
      },
      {
        "id": "improved",
        "label": "En çok gelişim gösteren",
        "title": "En Çok Gelişim Gösteren",
        "phrases": [
          "Yıl boyunca çok çalışıp harika bir ilerleme kaydettiğin için.",
          "Zorlandığında bile asla pes etmediğin için. Ne kadar ilerlediğine bir bak!"
        ],
        "suffix": ""
      },
      {
        "id": "reading",
        "label": "Okuma şampiyonu",
        "title": "Okuma Şampiyonu",
        "phrases": [
          "Pek çok harika kitap okuduğun ve hikaye sevgini paylaştığın için.",
          "Elinden kitabı düşürmediğin ve anlatacak bir hikayen olduğu için."
        ],
        "suffix": ""
      },
      {
        "id": "attendance",
        "label": "Tam devamlılık",
        "title": "Tam Devamlılık",
        "phrases": [
          "Her gün tam zamanında burada olduğun için.",
          "Dönemin her günü öğrenmeye hazır bir şekilde okula geldiğin için."
        ],
        "suffix": ""
      },
      {
        "id": "kindness",
        "label": "Nezaket ödülü",
        "title": "Nezaket Ödülü",
        "phrases": [
          "Her zaman nazik, düşünceli ve arkadaşlarına yardıma hazır olduğun için.",
          "Sınıfımızdaki herkesin kendini değerli ve dahil edilmiş hissetmesini sağladığın için."
        ],
        "suffix": ""
      },
      {
        "id": "math",
        "label": "Matematik dehası",
        "title": "Matematik Dehası",
        "phrases": [
          "Kıvrak zekan ve problem çözmeye olan gerçek sevgin için.",
          "Matematikte çok çalıştığın ve zorluklar karşısında asla geri adım atmadığın için."
        ],
        "suffix": ""
      },
      {
        "id": "helper",
        "label": "Harika yardımcı",
        "title": "Harika Yardımcı",
        "phrases": [
          "Öğretmenine ve sınıf arkadaşlarına yardım etmeye her zaman koştuğun için.",
          "Herkes için yardımsever ve güvenilir bir arkadaş olduğun için."
        ],
        "suffix": ""
      },
      {
        "id": "speller",
        "label": "Yazım ustası",
        "title": "Yazım Ustası",
        "phrases": [
          "Yazım kurallarına çok çalıştığın ve zor kelimelerin üstesinden geldiğin için.",
          "Tüm yazılarında dikkatli ve hatasız yazım kullandığın için."
        ],
        "suffix": ""
      },
      {
        "id": "creative",
        "label": "Yaratıcı düşünür",
        "title": "Yaratıcı Düşünür",
        "phrases": [
          "Parlak fikirlerin, geniş hayal gücün ve kalıpların dışında düşündüğün için.",
          "Sorunları çözmek ve fikirlerini paylaşmak için yaratıcı yollar bulduğun için."
        ],
        "suffix": ""
      },
      {
        "id": "leadership",
        "label": "Liderlik",
        "title": "Liderlik Ödülü",
        "phrases": [
          "Davranışlarınla örnek olarak liderlik ettiğin ve başkalarının en iyi yönlerini ortaya çıkardığın için.",
          "Sınıfımızda sorumluluk sahibi ve saygılı bir lider olduğun için."
        ],
        "suffix": ""
      },
      {
        "id": "citizen",
        "label": "İyi vatandaş",
        "title": "İyi Vatandaş",
        "phrases": [
          "Herkese karşı saygılı, sorumluluk sahibi ve adil olduğun için.",
          "Sınıfımızı ve okulumuzu herkes için daha güzel bir yer hâline getirdiğin için."
        ],
        "suffix": ""
      },
      {
        "id": "worker",
        "label": "Çalışkan öğrenci",
        "title": "Çalışkan Öğrenci",
        "phrases": [
          "Her gün elinden gelenin en iyisini ortaya koyduğun için.",
          "Odaklanmayı sürdürdüğün ve her görevde özenle çalıştığın için."
        ],
        "suffix": ""
      },
      {
        "id": "science",
        "label": "Bilim yıldızı",
        "title": "Bilim Yıldızı",
        "phrases": [
          "Meraklı soruların, dikkatli gözlemlerin ve harika deneylerin için.",
          "Dünyanın nasıl işlediğini keşfetme sevgin için."
        ],
        "suffix": ""
      },
      {
        "id": "writing",
        "label": "Yazarlık ödülü",
        "title": "Yazarlık Ödülü",
        "phrases": [
          "Yaratıcı öykülerin ve özenle kaleme alınmış, anlamlı yazıların için.",
          "Yazılarını açık, düzenli ve ilgi çekici hâle getirmek için çok çalıştığın için."
        ],
        "suffix": ""
      },
      {
        "id": "sportsmanship",
        "label": "Sportmenlik",
        "title": "Sportmenlik Ödülü",
        "phrases": [
          "Adil oynadığın, arkadaşlarını desteklediğin ve harika bir takım arkadaşı olduğun için.",
          "Zarafetle kazandığın, gülümseyerek kaybettiğin ve her zaman elinden gelenin en iyisini yaptığın için."
        ],
        "suffix": ""
      },
      {
        "id": "artist",
        "label": "Sanatçı ödülü",
        "title": "Sanatçı Ödülü",
        "phrases": [
          "Yüzümüzü güldüren renkli ve hayal gücü dolu sanat çalışmaların için.",
          "Yaptığın her çalışmaya kattığın yaratıcılık ve özen için."
        ],
        "suffix": ""
      },
      {
        "id": "attitude",
        "label": "Olumlu tutum",
        "title": "Olumlu Tutum",
        "phrases": [
          "Her gün neşeli gülümsemen ve “yapabilirim” diyen olumlu tutumun için.",
          "Her zaman olumlu kaldığın ve başkalarının da olumlu kalmasına yardımcı olduğun için."
        ],
        "suffix": ""
      },
      {
        "id": "listener",
        "label": "Harika dinleyici",
        "title": "Harika Dinleyici",
        "phrases": [
          "Her gün dikkatle dinlediğin ve yönergeleri uyguladığın için.",
          "Başkalarını sabırla ve saygıyla dinlediğin için."
        ],
        "suffix": ""
      },
      {
        "id": "teamwork",
        "label": "Takım oyuncusu",
        "title": "Takım Oyuncusu",
        "phrases": [
          "Başkalarıyla uyum içinde çalıştığın ve grubunun başarısına katkıda bulunduğun için.",
          "Fikirlerini paylaştığın, sıranı beklediğin ve takım arkadaşlarını dinlediğin için."
        ],
        "suffix": ""
      },
      {
        "id": "eco",
        "label": "Doğa kahramanı",
        "title": "Doğa Kahramanı",
        "phrases": [
          "Geri dönüşüm yaparak, enerji tasarrufu sağlayarak ve okulumuzu yeşil tutarak gezegenimize sahip çıktığın için.",
          "Sınıfımızı ve okulumuzu temiz ve yeşil tutmaya yardımcı olduğun için."
        ],
        "suffix": ""
      }
    ],
    "thanks": [
      {
        "id": "volunteer",
        "label": "Sınıf gönüllüsü",
        "title": "Teşekkür Ederiz",
        "phrases": [
          "Sınıfımıza yardımcı olmak için zamanınızı cömertçe ayırdığınız için. Siz olmadan başaramazdık!",
          "Yıl boyunca gösterdiğiniz zaman, enerji ve nezaket için."
        ],
        "suffix": ""
      },
      {
        "id": "parent",
        "label": "Yardımcı veli",
        "title": "Teşekkür Ederiz",
        "phrases": [
          "Sınıfımızdaki tüm yardımlarınız ve her çocuğa verdiğiniz destek için.",
          "Bu yıl öğrencilerimizin gelişimine katkıda bulunmak için bizimle omuz omuza çalıştığınız için."
        ],
        "suffix": ""
      },
      {
        "id": "room-parent",
        "label": "Sınıf annesi / babası",
        "title": "Teşekkür Ederiz",
        "phrases": [
          "Bu yıl sınıfımız için kutlamalar, etkinlikler ve çok daha fazlasını organize ettiğiniz için.",
          "Sınıfımızdaki aileleri bir arada tuttuğunuz ve kutlamalarımızın sorunsuz geçmesini sağladığınız için."
        ],
        "suffix": ""
      },
      {
        "id": "speaker",
        "label": "Konuk konuşmacı",
        "title": "Teşekkür Ederiz",
        "phrases": [
          "Sınıfımızı ziyaret ederek bilgi ve deneyimlerinizi bizimle paylaştığınız için.",
          "Herkeste merak uyandıran ve soru sorma isteği kazandıran ilham verici ziyaretiniz için."
        ],
        "suffix": ""
      },
      {
        "id": "aide",
        "label": "Sınıf yardımcısı",
        "title": "Teşekkür Ederiz",
        "phrases": [
          "Her gün öğrencilerimize gösterdiğiniz sabır, ilgi ve özverili çalışmanız için.",
          "Öğrenme sürecimize ve sınıfımıza verdiğiniz tüm destekler için."
        ],
        "suffix": ""
      },
      {
        "id": "chaperone",
        "label": "Okul gezisi refakatçisi",
        "title": "Teşekkür Ederiz",
        "phrases": [
          "Okul gezimizde herkesin güvende ve mutlu kalmasına yardımcı olduğunuz için.",
          "Maceramıza katıldığınız ve bu günü unutulmaz kılmamıza yardımcı olduğunuz için."
        ],
        "suffix": ""
      },
      {
        "id": "donation",
        "label": "Cömert bağışçı",
        "title": "Teşekkür Ederiz",
        "phrases": [
          "Sınıfımıza yaptığınız cömert kitap ve malzeme bağışınız için.",
          "Sınıfımızı destekleme nezaketiniz ve öğrencilerimize keşfedecek daha çok imkân sunduğunuz için."
        ],
        "suffix": ""
      },
      {
        "id": "student-teacher",
        "label": "Stajyer öğretmen",
        "title": "Teşekkür Ederiz",
        "phrases": [
          "Sınıfımıza enerji, yaratıcılık ve ilgi kattığınız için.",
          "Özverili çalışmanız ve emeğiniz için. Öğrencilerimiz sizinle öğrenmeyi çok sevdi!"
        ],
        "suffix": ""
      },
      {
        "id": "class-helper",
        "label": "Sınıf nöbetçisi",
        "title": "Teşekkür Ederiz",
        "phrases": [
          "Her gün söylenmesine gerek kalmadan öğretmenine ve sınıf arkadaşlarına yardım ettiğin için.",
          "Sınıfımızın düzen içinde işlemesini sağlayan güvenilir bir yardımcı olduğun için."
        ],
        "suffix": ""
      }
    ],
    "closings": {
      "award": "Böyle harika çalışmaya devam et!",
      "thanks": "En içten teşekkürlerimizle."
    },
    "labels": {
      "award": "Başarı Belgesi",
      "thanks": "Teşekkür Belgesi"
    },
    "awardTitle": "Başarı Belgesi",
    "suffixes": [],
    "signers": [
      "Öğretmen",
      "Okul Müdürü",
      ""
    ],
    "dateStyles": [
      "ad",
      "blank"
    ],
    "papers": [
      "a4",
      "letter"
    ],
    "limits": {
      "title": 30,
      "phrase": 120,
      "field": 40
    },
    "defaults": {
      "kind": "award",
      "preset": {
        "award": "star",
        "thanks": "volunteer"
      },
      "customTitle": "",
      "phrase": 0,
      "customPhrase": "",
      "suffix": null,
      "template": "forest",
      "nameStyle": "blank",
      "school": "",
      "className": "",
      "signer": "Öğretmen",
      "teacher": "",
      "dateStyle": "ad",
      "date": "",
      "closing": true,
      "paper": "a4"
    }
  },
  "charades": [
    {
      "id": "animals",
      "name": "Hayvanlar",
      "easy": [
        "kedi",
        "köpek",
        "tavşan",
        "maymun",
        "fil",
        "zürafa",
        "aslan",
        "kaplan",
        "penguen",
        "kanguru",
        "kurbağa",
        "yılan",
        "timsah",
        "kaplumbağa",
        "yengeç",
        "kuş",
        "tavuk",
        "ördek",
        "domuz",
        "inek",
        "at",
        "koyun",
        "ayı",
        "kelebek",
        "arı",
        "japon balığı",
        "ahtapot",
        "balina",
        "fare",
        "baykuş",
        "salyangoz",
        "örümcek",
        "dinozor",
        "zebra"
      ],
      "hard": [
        "tavus kuşu",
        "deve",
        "gergedan",
        "ağaçkakan",
        "bukalemun",
        "yunus",
        "köpek balığı",
        "karınca",
        "sivrisinek",
        "yarasa",
        "fok balığı",
        "denizanası",
        "flamingo",
        "oklu kirpi",
        "tembel hayvan",
        "sincap",
        "goril",
        "kartal",
        "tırtıl"
      ]
    },
    {
      "id": "jobs",
      "name": "Meslekler",
      "easy": [
        "öğretmen",
        "doktor",
        "hemşire",
        "polis",
        "itfaiyeci",
        "aşçı",
        "çiftçi",
        "postacı",
        "kuaför",
        "ressam",
        "şarkıcı",
        "sihirbaz",
        "astronot",
        "pilot",
        "diş hekimi",
        "veteriner",
        "otobüs şoförü",
        "cankurtaran",
        "fırıncı",
        "fotoğrafçı",
        "palyaço",
        "dansçı",
        "tamirci",
        "kasiyer",
        "inşaat işçisi",
        "hayvanat bahçesi bakıcısı",
        "kütüphaneci",
        "bahçıvan",
        "okul geçidi görevlisi"
      ],
      "hard": [
        "muhabir",
        "avukat",
        "hakim",
        "bilim insanı",
        "arkeolog",
        "mühendis",
        "marangoz",
        "terzi",
        "haber spikeri",
        "tur rehberi",
        "uçuş görevlisi",
        "orkestra şefi",
        "tesisatçı",
        "gemi kaptanı",
        "mucit",
        "heykeltıraş",
        "film yönetmeni",
        "yazar",
        "hava durumu sunucusu",
        "dedektif",
        "cerrah"
      ]
    },
    {
      "id": "sports",
      "name": "Sporlar ve Oyunlar",
      "easy": [
        "koşu",
        "yüzme",
        "ip atlama",
        "basketbol",
        "futbol",
        "beyzbol",
        "voleybol",
        "masa tenisi",
        "badminton",
        "kaykay",
        "bisiklete binme",
        "buz pateni",
        "halat çekme",
        "yüksek atlama",
        "uzun atlama",
        "doğa yürüyüşü",
        "jimnastik",
        "hulahupla oynama",
        "bovling",
        "tenis",
        "suya dalış",
        "sörf",
        "kayak",
        "yakantop",
        "şınav",
        "seksek",
        "ebelemece",
        "saklambaç",
        "karate",
        "sandalye kapmaca"
      ],
      "hard": [
        "halter",
        "eskrim",
        "golf",
        "kürek çekme",
        "sırıkla atlama",
        "gülle atma",
        "cirit atma",
        "engelli koşu",
        "sumo güreşi",
        "judo",
        "kaya tırmanışı",
        "artistik buz pateni",
        "maraton",
        "yelken kanat",
        "kano",
        "mekik",
        "yoga",
        "snowboard",
        "okçuluk",
        "bayrak yarışı"
      ]
    },
    {
      "id": "food",
      "name": "Yiyecekler",
      "easy": [
        "elma",
        "muz",
        "karpuz",
        "üzüm",
        "ananas",
        "çilek",
        "dondurma",
        "pasta",
        "hamburger",
        "patates kızartması",
        "pizza",
        "ekmek",
        "sandviç",
        "spagetti",
        "sahanda yumurta",
        "haşlanmış mısır",
        "lolipop",
        "patlamış mısır",
        "sosisli sandviç",
        "kurabiye",
        "süt",
        "pamuk şeker",
        "çikolata",
        "portakal",
        "havuç",
        "peynir",
        "pankek",
        "mısır gevreği",
        "tako",
        "çorba"
      ],
      "hard": [
        "suşi",
        "brokoli",
        "alman simidi",
        "burrito",
        "limonata",
        "fıstık ezmesi",
        "kapkek",
        "waffle",
        "meyveli soğuk içecek",
        "salata",
        "erişte",
        "mantı",
        "hindistan cevizi",
        "avokado",
        "turşu",
        "mango",
        "marşmelov",
        "balonlu sakız",
        "acı biber",
        "köfte"
      ]
    },
    {
      "id": "actions",
      "name": "Eylemler",
      "easy": [
        "diş fırçalamak",
        "yüz yıkamak",
        "banyo yapmak",
        "uyumak",
        "yemek yemek",
        "su içmek",
        "giyinmek",
        "ayakkabı bağlamak",
        "saç taramak",
        "esnemek",
        "hapşırmak",
        "alkışlamak",
        "el sallamak",
        "zıplamak",
        "emeklemek",
        "merdiven çıkmak",
        "dans etmek",
        "şarkı söylemek",
        "gülmek",
        "ağlamak",
        "baloncuk üflemek",
        "uçurtma uçurmak",
        "çiçek sulamak",
        "köpek gezdirmek",
        "kitap okumak",
        "fotoğraf çekmek",
        "kapı açmak",
        "yerleri süpürmek",
        "bulaşık yıkamak",
        "sarılmak"
      ],
      "hard": [
        "çorap giymek",
        "burnunu silmek",
        "tırnak kesmek",
        "ütü yapmak",
        "tavada krep çevirmek",
        "saç kurutmak",
        "çamaşır katlamak",
        "kravat bağlamak",
        "asansöre binmek",
        "karşıdan karşıya geçmek",
        "ağır kutu taşımak",
        "anahtar aramak",
        "sivrisinek ısırması",
        "sakıza basmak",
        "özçekim yapmak",
        "esneme hareketi yapmak",
        "hokkabazlık yapmak",
        "parmak ucunda yürümek",
        "titremek",
        "örgü örmek",
        "duvar boyamak"
      ]
    },
    {
      "id": "school",
      "name": "Okulda",
      "easy": [
        "kurşun kalem",
        "silgi",
        "sırt çantası",
        "makas",
        "yapıştırıcı",
        "pastel boya",
        "cetvel",
        "okul sırası",
        "beyaz tahta",
        "defter",
        "beslenme çantası",
        "matara",
        "teneffüs",
        "parmak kaldırmak",
        "sıraya girmek",
        "ev ödevi",
        "yazım testi",
        "öğle yemeği vakti",
        "kaydırak",
        "salıncak",
        "tahterevalli",
        "kalem açmak",
        "okul bahçesi",
        "göster ve anlat",
        "masal saati",
        "boya fırçası",
        "kalem kutusu",
        "okul servisi",
        "tırmanma demiri"
      ],
      "hard": [
        "mikroskop",
        "yer küre",
        "hesap makinesi",
        "fen deneyi",
        "sözlük",
        "çarpım tablosu",
        "yangın tatbikatı",
        "okul gezisi",
        "okul piyesi",
        "mezuniyet töreni",
        "sınıf fotoğrafı",
        "spor şenliği",
        "kütüphane kartı",
        "duyuru panosu",
        "zımba",
        "fosforlu kalem",
        "koridor izin kartı",
        "heceleme yarışması",
        "kitap fuarı"
      ]
    },
    {
      "id": "home",
      "name": "Ev Eşyaları",
      "easy": [
        "yatak",
        "yastık",
        "battaniye",
        "kanepe",
        "masa",
        "sandalye",
        "lamba",
        "pencere",
        "küvet",
        "diş fırçası",
        "havlu",
        "sabun",
        "ayna",
        "televizyon",
        "buzdolabı",
        "fırın",
        "duvar saati",
        "telefon",
        "bardak",
        "kaşık",
        "çatal",
        "tabak",
        "oyuncak ayı",
        "süpürge",
        "çöp kutusu",
        "çamaşır makinesi",
        "şemsiye",
        "plastik ördek",
        "lavabo",
        "anahtar"
      ],
      "hard": [
        "elektrikli süpürge",
        "mikrodalga fırın",
        "ekmek kızartma makinesi",
        "kapı zili",
        "tavan vantilatörü",
        "kitaplık",
        "çamaşır sepeti",
        "bulaşık makinesi",
        "çalar saat",
        "saç kurutma makinesi",
        "mikser",
        "uzaktan kumanda",
        "ranza",
        "el feneri",
        "elbise askısı",
        "posta kutusu",
        "elektrik düğmesi",
        "duman dedektörü"
      ]
    },
    {
      "id": "places",
      "name": "Mekanlar",
      "easy": [
        "park",
        "plaj",
        "hayvanat bahçesi",
        "çiftlik",
        "kütüphane",
        "hastane",
        "süpermarket",
        "havaalanı",
        "tren istasyonu",
        "ekmek fırını",
        "yüzme havuzu",
        "orman",
        "dağ",
        "nehir",
        "kale",
        "müze",
        "restoran",
        "itfaiye istasyonu",
        "evcil hayvan dükkanı",
        "oyuncakçı",
        "otobüs durağı",
        "bahçe",
        "çöl",
        "ada",
        "balta girmemiş orman",
        "mağara",
        "sirk",
        "sinema"
      ],
      "hard": [
        "akvaryum",
        "banka",
        "postane",
        "kuaför salonu",
        "diş kliniği",
        "bovling salonu",
        "lunapark",
        "yanardağ",
        "deniz feneri",
        "gökdelen",
        "kamp alanı",
        "şelale",
        "inşaat alanı",
        "çamaşırhane",
        "benzin istasyonu",
        "semt pazarı",
        "uzay istasyonu",
        "perili ev",
        "eskimo evi"
      ]
    },
    {
      "id": "feelings",
      "name": "Duygular",
      "easy": [
        "mutlu",
        "üzgün",
        "kızgın",
        "korkmuş",
        "şaşkın",
        "yorgun",
        "uykulu",
        "aç",
        "susamış",
        "heyecanlı",
        "sıkılmış",
        "utangaç",
        "komik",
        "gururlu",
        "üşümüş",
        "sıcaklamış",
        "hasta",
        "huysuz",
        "endişeli",
        "cesur",
        "sakin",
        "yalnız",
        "rahat ve huzurlu",
        "başı dönmüş",
        "kafası karışmış",
        "gıdıklanan"
      ],
      "hard": [
        "gergin",
        "utanmış",
        "bunaldım",
        "kıskanç",
        "hayal kırıklığına uğramış",
        "meraklı",
        "rahatlamış",
        "minnettar",
        "sabırsız",
        "özgüvenli",
        "iğrenmiş",
        "şok olmuş",
        "umutlu",
        "inatçı",
        "sinsi",
        "bitkin",
        "kararlı",
        "şaşırmış kalmış"
      ]
    },
    {
      "id": "seasons",
      "name": "Tatil ve Mevsimler",
      "easy": [
        "doğum günü partisi",
        "mum üflemek",
        "hediye paketi açmak",
        "havai fişek",
        "kardan adam",
        "kartopu savaşı",
        "kızakla kaymak",
        "yaprakları tırmıklamak",
        "su birikintisinde zıplamak",
        "gökkuşağı",
        "güneş gözlüğü",
        "kumdan kale",
        "buzlu dondurma",
        "piknik",
        "tohum ekmek",
        "balkabağı",
        "kostüm partisi",
        "geçit töreni",
        "sıcak çikolata",
        "kışlık eldiven",
        "atkı",
        "güneş kremi",
        "gök gürültülü fırtına",
        "deniz topu",
        "kamp gezisi",
        "dökülen yapraklar"
      ],
      "hard": [
        "yılbaşı geri sayımı",
        "şeker toplama",
        "balkabağı oymak",
        "elma toplamak",
        "hediye paketlemek",
        "dilek tutmak",
        "bahar temizliği",
        "yaz tatili",
        "sıcak hava dalgası",
        "kar fırtınası",
        "dolu yağışı",
        "sonbahar şenliği",
        "aile buluşması",
        "kar tatili",
        "kurabiye ev",
        "yumurta avı",
        "maytap",
        "saman arabası gezisi",
        "limonata tezgahı"
      ]
    }
  ],
  "grades": [
    {
      "label": "Okul Öncesi",
      "options": [
        {
          "value": "k1",
          "label": "Okul Öncesi (3–4 yaş)"
        },
        {
          "value": "k2",
          "label": "Okul Öncesi (4–5 yaş)"
        },
        {
          "value": "k3",
          "label": "Anaokulu (5–6 yaş)"
        }
      ]
    },
    {
      "label": "İlkokul",
      "options": [
        {
          "value": "g1",
          "label": "1. Sınıf"
        },
        {
          "value": "g2",
          "label": "2. Sınıf"
        },
        {
          "value": "g3",
          "label": "3. Sınıf"
        },
        {
          "value": "g4",
          "label": "4. Sınıf"
        }
      ]
    },
    {
      "label": "Ortaokul",
      "options": [
        {
          "value": "g5",
          "label": "5. Sınıf"
        },
        {
          "value": "g6",
          "label": "6. Sınıf"
        },
        {
          "value": "g7",
          "label": "7. Sınıf"
        },
        {
          "value": "g8",
          "label": "8. Sınıf"
        }
      ]
    },
    {
      "label": "Lise",
      "options": [
        {
          "value": "g9",
          "label": "9. Sınıf (Lise 1)"
        },
        {
          "value": "g10",
          "label": "10. Sınıf (Lise 2)"
        },
        {
          "value": "g11",
          "label": "11. Sınıf (Lise 3)"
        },
        {
          "value": "g12",
          "label": "12. Sınıf (Lise 4)"
        }
      ]
    },
    {
      "label": "Diğer",
      "options": [
        {
          "value": "mixed",
          "label": "Karma Yaş / Etüt"
        },
        {
          "value": "adult",
          "label": "Üniversite / Yetişkin"
        },
        {
          "value": "other",
          "label": "Diğer / Geçerli Değil"
        }
      ]
    }
  ],
  "comments": {
    "traits": {
      "focus": {
        "kw": "derste dikkatli dinleme",
        "lines": [
          "{N} derste dikkatle {dinler ve her dersi yakından takip eder|dinliyorsun ve her dersi yakından takip ediyorsun}.",
          "{○○ ders sırasında görevine bağlı kalan, odaklanmış bir öğrencidir|Ders sırasında görevine bağlı kalan, odaklanmış bir öğrencisin}.",
          "Dersler sırasında {N} gözlerini konuşmacıdan {ayırmaz ve yönergeleri ilk seferde anlar|ayırmıyorsun ve yönergeleri ilk seferde anlıyorsun}.",
          "Odaklanma becerisi, {○○ adlı öğrencinin yeni konuları hızla öğrenmesine yardımcı oluyor|yeni konuları hızla öğrenmene yardımcı oluyor}.",
          "Sınıf hareketli olduğunda bile {N} {elindeki çalışmaya odaklanır|elindeki çalışmaya odaklanıyorsun}.",
          "{○○ yönergeleri dikkatle dinler ve vakit kaybetmeden çalışmaya başlar|Yönergeleri dikkatle dinliyor ve vakit kaybetmeden çalışmaya başlıyorsun}."
        ]
      },
      "effort": {
        "kw": "güçlü çalışma disiplini",
        "lines": [
          "{N} her göreve gerçek bir çaba {gösterir ve işini iyi yapmaktan gurur duyar|gösteriyor ve işini iyi yapmaktan gurur duyuyorsun}.",
          "{○○ dönem boyunca güçlü bir çalışma disiplini sergiledi|Dönem boyunca güçlü bir çalışma disiplini sergiledin}.",
          "{N} ister kolay ister zor olsun, her ödeve tüm {çabasını verir|çabanı veriyorsun}.",
          "Çalışkanlık, {○○ adlı öğrencinin en güçlü yönlerinden biridir|en güçlü yönlerinden biridir}.",
          "{○○ bir işi iyi yapmak için gereken zamanı ayırmaya isteklidir|Bir işi iyi yapmak için gereken zamanı ayırmaya isteklisin}.",
          "{○○ adlı öğrencinin öğrenmeyi ciddiye aldığı ve her zaman elinden gelenin en iyisini hedeflediği|Öğrenmeyi ciddiye aldığın ve her zaman elinden gelenin en iyisini hedeflediğin} açıkça görülüyor."
        ]
      },
      "homework": {
        "kw": "düzenli ve eksiksiz ödev",
        "lines": [
          "{N} {ödevlerini düzenli olarak eksiksiz, özenli ve zamanında teslim eder|ödevlerini düzenli olarak eksiksiz, özenli ve zamanında teslim ediyorsun}.",
          "{○○ adlı öğrencinin ödevleri|Ödevlerin} özen ve detaylara verilen dikkati gösteriyor.",
          "Ödevler zamanında teslim ediliyor ve gerçek bir özen gösteriyor.",
          "{N} {ödevlerini eksiksiz tamamlar ve düzenli bir şekilde sunar|ödevlerini eksiksiz tamamlıyor ve düzenli bir şekilde sunuyorsun}.",
          "{○○ ödevlerini ciddiye alır ve bu durum yaptığı çalışmaların kalitesine yansır|Ödevlerini ciddiye alıyorsun ve bu durum yaptığın çalışmaların kalitesine yansıyor}.",
          "{○○ adlı öğrencinin ödevleri|Ödevlerin} her zaman düzenli, eksiksiz ve iyi düşünülmüştür."
        ]
      },
      "speak": {
        "kw": "özgüvenli katılım",
        "lines": [
          "{N} tartışmalara aktif olarak {katılır ve fikirlerini özgüvenle paylaşır|katılıyor ve fikirlerini özgüvenle paylaşıyorsun}.",
          "{○○ parmak kaldırıp sınıf içi tartışmalara katkıda bulunmaya her zaman isteklidir|Parmak kaldırıp sınıf içi tartışmalara katkıda bulunmaya her zaman isteklisin}.",
          "{N} {fikirlerini paylaşmakta hızlıdır ve sınıf içi sohbetlere çok şey katar|fikirlerini paylaşmakta hızlısın ve sınıf içi sohbetlere çok şey katıyorsun}.",
          "{○○ adlı öğrencinin düşünceli katkıları|Düşünceli katkıların} sayesinde sınıf içi tartışmalar daha verimli geçiyor.",
          "{○○ özgüvenle söz alır ve başkalarının fikirlerini geliştirir|Özgüvenle söz alıyor ve başkalarının fikirlerini geliştiriyorsun}.",
          "Bir soru sorulduğunda, {N} genellikle ilk yanıt verenlerden {biridir|birisin}."
        ]
      },
      "curious": {
        "kw": "doğal merak",
        "lines": [
          "{N} öğrenmeye doğal bir merakla {yaklaşır ve sık sık düşündürücü sorular sorar|yaklaşıyor ve sık sık düşündürücü sorular soruyorsun}.",
          "{○○ yeni fikirleri keşfetmeye ve olayların nasıl işlediğini anlamaya heveslidir|Yeni fikirleri keşfetmeye ve olayların nasıl işlediğini anlamaya heveslisin}.",
          "{○○ adlı öğrencinin merakı|Merakın}, tüm sınıfın daha derin düşünmesine yardımcı olan harika sorular doğuruyor.",
          "{N} olayların neden gerçekleştiğini ve nasıl işlediğini öğrenmeyi çok {sever|seviyorsun}.",
          "Yeni konular {○○ adlı öğrencinin ilgisini uyandırır ve kendisi her zaman daha fazlasını öğrenmeye isteklidir|ilgini uyandırıyor ve her zaman daha fazlasını öğrenmeye isteklisin}.",
          "{○○ gerçek bir düşünce ve anlama isteği gösteren sorular sorar|Gerçek bir düşünce ve anlama isteği gösteren sorular soruyorsun}."
        ]
      },
      "reading": {
        "kw": "okuma sevgisi",
        "lines": [
          "{N} gerçek bir okuma sevgisine {sahiptir ve sık sık elinde bir kitapla görülebilir|sahipsin ve sık sık elinde bir kitapla görülebilirsin}.",
          "{○○ adlı öğrencinin okuma alışkanlığı|Okuma alışkanlığın}, zengin bir kelime dağarcığı ve geniş bir bilgi birikimi oluşturmaya yardımcı oldu.",
          "{N} çok çeşitli kitaplar {okur ve sevdiği kitaplar hakkında konuşmaktan keyif alır|okuyor ve sevdiğin kitaplar hakkında konuşmaktan keyif alıyorsun}.",
          "Okuma saati, {○○ adlı öğrencinin gününün|gününün} en sevilen anlarından biridir.",
          "{○○ kitapları hevesle seçer ve giderek artan bir akıcılık ve anlayışla okur|Kitapları hevesle seçiyor ve giderek artan bir akıcılık ve anlayışla okuyorsun}.",
          "Kitap sevgisi, {○○ adlı öğrencinin kelime dağarcığında ve yazılı çalışmalarında|kelime dağarcığında ve yazılı çalışmalarında} kendini gösteriyor."
        ]
      },
      "careful": {
        "kw": "dikkatli ve doğru çalışma",
        "lines": [
          "{N} dikkatle {çalışır ve çalışmasını teslim etmeden önce doğruluğunu kontrol eder|çalışıyor ve çalışmanı teslim etmeden önce doğruluğunu kontrol ediyorsun}.",
          "{○○ her görevde detaylara büyük özen gösterir|Her görevde detaylara büyük özen gösteriyorsun}.",
          "{N} detayları doğru yapmak için zaman {ayırır ve çalışmasını nadiren aceleye getirir|ayırıyor ve çalışmanı nadiren aceleye getiriyorsun}.",
          "{○○ adlı öğrencinin çalışmaları|Çalışmaların} doğru, eksiksiz ve özenle sunulmuştur.",
          "{○○ yanıtlarını dikkatle kontrol eder ve çalışmasını teslim etmeden önce küçük hataları düzeltir|Yanıtlarını dikkatle kontrol ediyor ve çalışmanı teslim etmeden önce küçük hataları düzeltiyorsun}.",
          "Detaylara dikkat etmek, {○○ adlı öğrencinin günlük çalışmalarında|günlük çalışmalarında} gerçekten güçlü bir yöndür."
        ]
      },
      "selfdriven": {
        "kw": "bağımsızlık ve girişimcilik",
        "lines": [
          "{N} öğrenme sürecinde inisiyatif {alır ve görevleri hatırlatmaya gerek kalmadan tamamlar|alırsın ve görevleri hatırlatmaya gerek kalmadan tamamlarsın}.",
          "{○○ kendini geliştirmek için yollar arayan, içsel motivasyonu yüksek bir öğrencidir|Kendini geliştirmek için yollar arayan, içsel motivasyonu yüksek bir öğrencisin}.",
          "{N} çalışmalara hemen {başlar ve bağımsız olarak çok iyi çalışır|başlarsın ve bağımsız olarak çok iyi çalışırsın}.",
          "{○○ kendine hedefler koyar ve bunlara ulaşmak için istikrarlı bir şekilde çalışır|Kendine hedefler koyarsın ve bunlara ulaşmak için istikrarlı bir şekilde çalışırsın}.",
          "{Kendisinden|Senden} istenmeden de {N} sık sık daha fazlasını öğrenmenin yollarını {arar|ararsın}.",
          "{○○ görevlerine odaklanmak için çok az hatırlatmaya ihtiyaç duyan istekli bir öğrencidir|Görevlerine odaklanmak için çok az hatırlatmaya ihtiyaç duyan istekli bir öğrencisin}."
        ]
      },
      "persist": {
        "kw": "azim ve kararlılık",
        "lines": [
          "{N} büyük bir azim {gösterir ve zorlayıcı çalışmalarda çabalamaktan vazgeçmez|gösterirsin ve zorlayıcı çalışmalarda çabalamaktan vazgeçmezsin}.",
          "{○○ kolay kolay pes etmez ve zorlukların üstesinden gelmek için sıkı çalışır|Kolay kolay pes etmezsin ve zorlukların üstesinden gelmek için sıkı çalışırsın}.",
          "{N} çalışmalar zorlaştığında bile devam {eder ve başladığı işi sonuna kadar götürür|edersin ve başladığın işi sonuna kadar götürürsün}.",
          "Zorluklar {○○ adlı öğrencimizin cesaretini kırmaz; aksine yeni bir yaklaşımla tekrar dener|cesaretini kırmaz; aksine yeni bir yaklaşımla tekrar denersin}.",
          "Bir çalışma fazladan çaba gerektirdiğinde {○○ adlı öğrencimizin kararlılığı|kararlılığın} hemen fark edilir.",
          "{○○ hataların öğrenmenin bir parçası olduğunu bilir ve denemeye devam eder|Hataların öğrenmenin bir parçası olduğunu bilirsin ve denemeye devam edersin}."
        ]
      },
      "kind": {
        "kw": "nezaket ve duyarlılık",
        "lines": [
          "{N} {çevresindekilere karşı nezaket ve empati gösterir|çevrendekilere karşı nezaket ve empati gösterirsin}.",
          "{○○ şefkatli ve düşüncelidir; sınıf arkadaşları onun yanında kendilerini rahat hisseder|Şefkatli ve düşüncelisin; sınıf arkadaşların senin yanında kendilerini rahat hisseder}.",
          "{N} başkalarının desteğe ihtiyaç duyduğunu fark {eder ve içtenlikle yaklaşır|edersin ve içtenlikle yaklaşırsın}.",
          "{○○ adlı öğrencimizin duyarlı yapısı|Duyarlı yapın}, sınıf arkadaşlarının kendilerini değerli ve güvende hissetmesini sağlar.",
          "Küçük iyilikler {○○ adlı öğrencimizin gününün|gününün} doğal bir parçasıdır.",
          "{○○ başkalarına nazik davranır ve onların nasıl hissettiğini önemser|Başkalarına nazik davranırsın ve onların nasıl hissettiğini önemsersin}."
        ]
      },
      "honest": {
        "kw": "dürüstlük",
        "lines": [
          "{N} {dürüsttür ve hatalarının sorumluluğunu üstlenir|dürüstsün ve hatalarının sorumluluğunu üstlenirsin}.",
          "{○○ dürüstlüğüyle öğretmenlerinin ve sınıf arkadaşlarının güvenini kazanmıştır|Dürüstlüğünle öğretmenlerinin ve sınıf arkadaşlarının güvenini kazandın}.",
          "{N} zor olduğunda bile doğruyu {söyler|söylersin}.",
          "{○○, dürüstlüğü sayesinde herkesin güvenebileceği biridir|Dürüstlüğün sayesinde herkesin güvenebileceği birisin}.",
          "{○○ hatalarını kabul eder ve bunlardan ders çıkarır|Hatalarını kabul edersin ve bunlardan ders çıkarırsın}.",
          "Öğretmenleri ve sınıf arkadaşları {○○ adlı öğrencimizin sözüne|sözüne} güvenilebileceğini bilir."
        ]
      },
      "polite": {
        "kw": "görgü ve nezaket",
        "lines": [
          "{N} öğretmenlerine ve sınıf arkadaşlarına karşı nazik ve {saygılıdır|saygılısın}.",
          "{○○ adlı öğrencimizin görgüsü ve nezaketi|Görgün ve nezaketin} okuldaki herkes tarafından fark edilir.",
          "{N} hatırlatmaya gerek kalmadan lütfen ve teşekkür ederim gibi nezaket ifadelerini {kullanır|kullanırsın}.",
          "{○○ adlı öğrencimizin nazik tavrı|Nazik tavrın} herkes üzerinde olumlu bir izlenim bırakır.",
          "{○○ yetişkinleri ve sınıf arkadaşlarını içtenlikle selamlar ve saygılı konuşur|Yetişkinleri ve sınıf arkadaşlarını içtenlikle selamlarsın ve saygılı konuşursun}.",
          "Hem sınıfta hem de okul genelinde nazik ve görgülü davranmak {○○ için|senin için} çok doğaldır."
        ]
      },
      "responsible": {
        "kw": "güçlü sorumluluk bilinci",
        "lines": [
          "Görevleri tamamlama ve işleri sonuçlandırma konusunda {○○ adlı öğrencimize|sana} her zaman güvenilebilir.",
          "{○○ sorumluluklarını ciddiye alır ve sınıfın güvenilir bir üyesidir|Sorumluluklarını ciddiye alırsın ve sınıfın güvenilir bir üyesisin}.",
          "{N} verdiği sözleri {tutar ve önemli görevlerde kendisine güvenilebilir|tutarsın ve önemli görevlerde sana güvenilebilir}.",
          "{○○ adlı öğrencimizin güvenilirliği|Güvenilirliğin}, öğretmenlerinin ve sınıf arkadaşlarının her zaman güvendiği bir özelliktir.",
          "Bir görev verildiğinde, {N} bunu sonuna kadar özenle {tamamlar|tamamlarsın}.",
          "{○○ verilen görevleri ve kişisel eşyalarını sahiplenir|Verilen görevleri ve kişisel eşyalarını sahiplenirsin}."
        ]
      },
      "positive": {
        "kw": "olumlu tutum",
        "lines": [
          "{N} her gün sınıfa neşeli ve olumlu bir tutum {getirir|getirirsin}.",
          "{○○ adlı öğrencimizin iyimserliği ve neşesi|İyimserliğin ve neşen} sınıfın havasını aydınlatır.",
          "{N} her güne bir gülümseme ve pozitif bir bakış açısıyla {başlar|başlarsın}.",
          "{○○ adlı öğrencimizin coşkusu|Coşkun} bulaşıcıdır ve sınıfın enerjisini yükseltir.",
          "İşler zorlaştığında bile {N} neşeli ve umutlu {kalır|kalırsın}.",
          "{○○ sınıfımıza sıcaklık ve neşe katar|Sınıfımıza sıcaklık ve neşe katarsın}."
        ]
      },
      "confident": {
        "kw": "öz güven",
        "lines": [
          "{N} yeni zorluklara öz güvenle {yaklaşır|yaklaşırsın}.",
          "{○○ yeni şeyler denemeye isteklidir ve hata yapmaktan korkmaz|Yeni şeyler denemeye isteklisin ve hata yapmaktan korkmazsın}.",
          "{N} aşina {olmadığı|olmadığın} görevleri \"yapabilirim\" tutumuyla ele {alır|alırsın}.",
          "{○○ adlı öğrencimizin öz güveni|Öz güvenin}, çalışmalarını paylaşırken veya yeni bir şey denerken kendini gösterir.",
          "{○○ zorlukları üstlenmekten mutluluk duyar ve zor sorulardan çekinmez|Zorlukları üstlenmekten mutluluk duyarsın ve zor sorulardan çekinmezsin}.",
          "{N} yeni durumlara sakin ve kendine güvenen bir tavırla {yaklaşır|yaklaşırsın}."
        ]
      },
      "helpful": {
        "kw": "yardımseverlik",
        "lines": [
          "{N} desteğe ihtiyaç duyan sınıf arkadaşlarına yardım etmeye her zaman {hazırdır|hazırsın}.",
          "{○○ sık sık yardım eli uzatır ve arkadaşlarına konuları sabırla açıklar|Sık sık yardım eli uzatırsın ve arkadaşlarına konuları sabırla açıklarsın}.",
          "{N} birinin zorlandığını fark {eder ve hemen destek teklif eder|edersin ve hemen destek teklif edersin}.",
          "{○○ adlı öğrencimizin yardım etme isteği|Yardım etme isteğin} sınıf arkadaşları için gerçek bir fark yaratır.",
          "Sınıf arkadaşları yardım için sık sık {○○ adlı öğrencimize başvurur ve o da her zaman mutlulukla yardımcı olur|sana başvurur ve sen de her zaman mutlulukla yardımcı olursun}.",
          "{○○ istenmesine gerek kalmadan, her zaman güler yüzle başkalarına yardım eder|İstenmesine gerek kalmadan, her zaman güler yüzle başkalarına yardım edersin}."
        ]
      },
      "teamwork": {
        "kw": "ekip çalışması",
        "lines": [
          "{N} grup çalışmalarında başkalarını dinleyerek ve iş yükünü paylaşarak uyum içinde {çalışır|çalışırsın}.",
          "{○○ grubun başarılı olmasına yardımcı olan iş birliğine açık bir ekip üyesidir|Grubun başarılı olmasına yardımcı olan iş birliğine açık bir ekip üyesisin}.",
          "{N} grup çalışmalarında {fikirleriyle katkıda bulunur ve başkalarının katkılarına değer verir|fikirlerinle katkıda bulunursun ve başkalarının katkılarına değer verirsin}.",
          "Grup projelerinde {N} görevleri adil bir şekilde {paylaşır ve ekip arkadaşlarını teşvik eder|paylaşırsın ve ekip arkadaşlarını teşvik edersin}.",
          "{○○ adlı öğrencimizin iş birliği ruhu|İş birliği ruhun}, grupların uyum içinde çalışmasına yardımcı olur.",
          "{○○ tüm ekibin başarılı olabilmesi için nasıl uzlaşılacağını bilir|Tüm ekibin başarılı olabilmesi için nasıl uzlaşılacağını bilirsin}."
        ]
      },
      "friendly": {
        "kw": "arkadaş canlısı tutum",
        "lines": [
          "{N} sınıf arkadaşlarıyla iyi {anlaşır ve pek çok kişi için iyi bir arkadaştır|anlaşırsın ve pek çok kişi için iyi bir arkadaşsın}.",
          "{○○ arkadaş canlısı ve kapsayıcıdır; başkalarının kendilerini kabul edilmiş hissetmesini sağlar|Arkadaş canlısı ve kapsayıcısın; başkalarının kendilerini kabul edilmiş hissetmesini sağlarsın}.",
          "{N} kolayca arkadaş {edinir ve oyunlara, etkinliklere başkalarını da dahil eder|edinirsin ve oyunlara, etkinliklere başkalarını da dahil edersin}.",
          "{○○ adlı öğrencimizin sıcak ve samimi tavrı|Sıcak ve samimi tavrın}, sınıf arkadaşlarının kendilerini rahat hissetmesine yardımcı olur.",
          "{○○ herkesle kolay anlaşan ve herkese nazik davranan biridir|Herkesle kolay anlaşan ve herkese nazik davranan birisin}.",
          "Sınıf arkadaşları hem derslerde hem de oyunlarda {○○ ile|seninle} vakit geçirmekten keyif alır."
        ]
      },
      "leader": {
        "kw": "liderlik",
        "lines": [
          "{N} güçlü liderlik becerileri {gösterir ve grup çalışmalarına etkili bir şekilde rehberlik eder|gösterirsin ve grup çalışmalarına etkili bir şekilde rehberlik edersin}.",
          "{○○ sınıf arkadaşlarının örnek aldığı doğal bir liderdir|Sınıf arkadaşlarının örnek aldığı doğal bir lidersin}.",
          "{N} grup görevlerinde başkalarını dinlemeye devam ederek liderliği {üstlenir|üstlenirsin}.",
          "Sınıf arkadaşları {○○ adlı öğrencimizin fikirlerine|fikirlerine} saygı duyar ve memnuniyetle uyum sağlar.",
          "{○○ grup çalışmalarını iyi organize eder ve herkesin bir rolü olmasını sağlar|Grup çalışmalarını iyi organize edersin ve herkesin bir rolü olmasını sağlarsın}.",
          "{○○ adlı öğrencimizin liderliği|Liderliğin} sakin, adil ve teşvik edicidir."
        ]
      },
      "respect": {
        "kw": "başkalarına saygı",
        "lines": [
          "{N} başkalarını saygıyla {dinler ve farklı bakış açılarına değer verir|dinlersin ve farklı bakış açılarına değer verirsin}.",
          "{○○ herkese saygıyla yaklaşır|Herkese saygıyla yaklaşırsın}.",
          "{N} konuşmak için sırasını {bekler ve sınıf arkadaşlarını dikkatle dinler|beklersin ve sınıf arkadaşlarını dikkatle dinlersin}.",
          "{○○ adlı öğrencimizin saygılı tutumu|Saygılı tutumun} olumlu bir sınıf ortamı oluşturulmasına yardımcı olur.",
          "{○○ farklılıkları kabul eder ve herkesle nazikçe konuşur|Farklılıkları kabul edersin ve herkesle nazikçe konuşursun}.",
          "{○○ adlı öğrencimizin dinleme ve yanıt verme biçiminde|Dinleme ve yanıt verme biçiminde} başkalarına duyulan saygı açıkça görülür."
        ]
      },
      "share": {
        "kw": "cömertlik ve paylaşımcılık",
        "lines": [
          "{N} fikirlerini ve materyallerini sınıf arkadaşlarıyla cömertçe {paylaşır|paylaşırsın}.",
          "{○○ öğrendiklerini başkalarıyla paylaşmaktan keyif alır|Öğrendiklerini başkalarıyla paylaşmaktan keyif alırsın}.",
          "{N} malzemelerini mutlulukla {paylaşır ve sorun çıkarmadan sırasını bekler|paylaşırsın ve sorun çıkarmadan sıranı beklersin}.",
          "{○○ adlı öğrencimizin paylaşımcı ruhu|Paylaşımcı ruhun} sınıftaki herkes tarafından takdir edilir.",
          "{○○ grup çalışmaları sırasında fikirlerini ve kaynaklarını hızla paylaşır|Grup çalışmaları sırasında fikirlerini ve kaynaklarını hızla paylaşırsın}.",
          "İster malzeme ister fikir veya zaman olsun, paylaşmak {○○ için|senin için} çok doğaldır."
        ]
      },
      "tidy": {
        "kw": "düzenlilik",
        "lines": [
          "{○○ sırasını temiz, eşyalarını ve materyallerini düzenli tutar|Sıranı temiz, eşyalarını ve materyallerini düzenli tutarsın}.",
          "{○○ çok düzenlidir ve derslere her zaman hazırdır|Çok düzenlisin ve derslere her zaman hazırsın}.",
          "{○○ adlı öğrencimizin çalışma alanı her zaman düzenlidir ve malzemeleri kolayca bulunur|Çalışma alanın her zaman düzenlidir ve malzemelerin kolayca bulunur}.",
          "{N} kitaplarını ve malzemelerini düzenli {tutar ve onlara özen gösterir|tutarsın ve onlara özen gösterirsin}.",
          "Etkinliklerden sonra {N} hızlıca {toplanır ve alanı temiz bırakır|toplanırsın ve alanı temiz bırakırsın}.",
          "Düzenli olmak, {○○ adlı öğrencimizin her derse öğrenmeye hazır başlamasına|her derse öğrenmeye hazır başlamana} yardımcı olur."
        ]
      },
      "punctual": {
        "kw": "dakiklik",
        "lines": [
          "{N} her gün zamanında ve öğrenmeye hazır bir şekilde sınıfa {gelir|gelirsin}.",
          "{○○ zamanı iyi yönetir ve çalışmalarını zamanında tamamlar|Zamanı iyi yönetirsin ve çalışmalarını zamanında tamamlarsın}.",
          "{N} dersler başladığında her zaman zamanında sınıfta ve {hazırdır|hazırsın}.",
          "{○○ adlı öğrencimizin dakikliği, her okul gününden en iyi şekilde yararlanmasına|Dakikliğin, her okul gününden en iyi şekilde yararlanmana} yardımcı olur.",
          "{○○ çalışmalarını zamanında teslim eder ve zamanı verimli kullanır|Çalışmalarını zamanında teslim edersin ve zamanı verimli kullanırsın}.",
          "Zamanında ve hazırlıklı gelmek, {○○ adlı öğrencimizin açıkça edindiği|açıkça edindiğin} bir alışkanlıktır."
        ]
      },
      "rules": {
        "kw": "öz disiplin",
        "lines": [
          "{N} sınıf rutinlerine {uyar ve arkadaşlarına iyi örnek olur|uyarsın ve arkadaşlarına iyi örnek olursun}.",
          "{○○ mükemmel bir öz disiplin ve sınıf kurallarına saygı gösterir|Mükemmel bir öz disiplin ve sınıf kurallarına saygı gösterirsin}.",
          "{N} sınıf beklentilerini {anlar ve bunlara istikrarlı bir şekilde uyar|anlarsın ve bunlara istikrarlı bir şekilde uyarsın}.",
          "{○○ adlı öğrencimizin sakin ve sağduyulu davranışı|Sakin ve sağduyulu davranışın} başkaları için örnek teşkil eder.",
          "{○○ hiçbir yetişkin izlemiyorken bile doğru seçimler yapar|Hiçbir yetişkin izlemiyorken bile doğru seçimler yaparsın}.",
          "Sınıf rutinleri, {○○ adlı öğrencimizin yardımı ve iş birliğiyle|yardımın ve iş birliğinle} sorunsuz ilerler."
        ]
      },
      "independent": {
        "kw": "öz bakım ve bağımsızlık",
        "lines": [
          "{N} günlük rutinlerini bağımsız olarak {yönetir|yönetirsin}.",
          "{○○ kişisel eşyalarıyla ve görevleriyle yardım almadan ilgilenir|Kişisel eşyalarınla ve görevlerinle yardım almadan ilgilenirsin}.",
          "{N} kişisel eşyalarına sahip {çıkar ve yardım almadan her derse hazırlanır|çıkarsın ve yardım almadan her derse hazırlanırsın}.",
          "{○○ adlı öğrencimizin günlük rutinlerdeki bağımsızlığı|Günlük rutinlerdeki bağımsızlığın} etkileyicidir.",
          "{○○ günlük görevleri öz güvenle yerine getirir ve yalnızca gerektiğinde yardım ister|Günlük görevleri öz güvenle yerine getirirsin ve yalnızca gerektiğinde yardım istersin}.",
          "{Eşyalarını toplamak ve etkinlikler arasında geçiş yapmak ○○ adlı öğrencimizin kolaylıkla yaptığı|Eşyalarını toplamak ve etkinlikler arasında geçiş yapmak kolaylıkla yaptığın} şeylerdir."
        ]
      },
      "cleaning": {
        "kw": "sınıf düzeni ve temizliğinde özen",
        "lines": [
          "{N} temizlik görevlerini ciddiye {alır ve sorumlu olduğu alanı tertemiz bırakır|alırsın ve sorumlu olduğun alanı tertemiz bırakırsın}.",
          "{○○ sınıf toplama ve temizlik saatlerinde çok çalışkandır|Sınıf toplama ve temizlik saatlerinde çok çalışkansın}.",
          "{N} toparlanma zamanında sıkı {çalışır ve her köşeye özen gösterir|çalışırsın ve her köşeye özen gösterirsin}.",
          "{○○ adlı öğrencimizin temizlik görevleri|Temizlik görevlerin} her zaman eksiksiz ve şikayet etmeden yapılır.",
          "{○○ sınıfımızı temiz ve düzenli tutmaktan gurur duyar|Sınıfımızı temiz ve düzenli tutmaktan gurur duyarsın}.",
          "Toparlanma zamanında, işi iyi bir şekilde bitirmesi konusunda {○○ adlı öğrencimize|sana} her zaman güvenilebilir."
        ]
      },
      "cadre": {
        "kw": "sınıf görevlerinde güvenilirlik",
        "lines": [
          "{N} sınıf içi görevlerini özenle ve güvenilir bir şekilde yerine {getirir|getirirsin}.",
          "Sınıf görevlisi olarak {○○ iyi bir örnek olur ve öğretmenine destek verir|iyi bir örnek olursun ve öğretmenine destek verirsin}.",
          "{N} sınıf görevlisi sorumluluklarını olgunlukla ve özenle yerine {getirir|getirirsin}.",
          "{○○ adlı öğrencimizin sınıf görevlisi olarak yaptığı güvenilir çalışmalar|Sınıf görevlisi olarak yaptığın güvenilir çalışmalar} herkes için büyük bir destektir.",
          "{○○ sınıf görevlerini hatırlatmaya gerek kalmadan yerine getirir ve güzel bir örnek olur|Sınıf görevlerini hatırlatmaya gerek kalmadan yerine getirirsin ve güzel bir örnek olursun}.",
          "Sınıf görevlerinde {N} {güvenilir, düzenli ve adildir|güvenilir, düzenli ve adilsin}."
        ]
      },
      "service": {
        "kw": "gönüllülük ve katkı bilinci",
        "lines": [
          "{N} sınıf işlerine istekle yardım {eder ve bunları ciddiye alır|edersin ve bunları ciddiye alırsın}.",
          "{○○ sınıfımızın düzeninin sorunsuz işlemesi için yardım eli uzatmaya her zaman hazırdır|Sınıfımızın düzeninin sorunsuz işlemesi için yardım eli uzatmaya her zaman hazırsın}.",
          "{N} yapılması gereken bir iş olduğunda hızla gönüllü {olur|olursun}.",
          "{○○ adlı öğrencimizin katkıda bulunma isteği|Katkıda bulunma isteğin} herkes tarafından çok takdir edilir.",
          "{○○ sınıf işlerine yardım etmeyi teklif eder ve bunları özenle tamamlar|Sınıf işlerine yardım etmeyi teklif edersin ve bunları özenle tamamlarsın}.",
          "Ne zaman yardıma ihtiyaç duyulsa, {N} öne çıkan ilk kişilerden {biridir|birisin}."
        ]
      },
      "sports": {
        "kw": "sportif yetenek",
        "lines": [
          "{N} beden eğitiminde çok {başarılıdır ve harika bir sportmenlik gösterir|başarılısın ve harika bir sportmenlik gösterirsin}.",
          "{○○ spor etkinliklerine enerji ve takım ruhu katar|Spor etkinliklerine enerji ve takım ruhu katarsın}.",
          "{N} beden eğitimi dersinde enerjik ve yetenekli bir şekilde {oynar ve takım arkadaşlarını teşvik eder|oynarsın ve takım arkadaşlarını teşvik edersin}.",
          "Fiziksel etkinliklerde {○○ adlı öğrencimizin koordinasyonu ve kondisyonu|koordinasyonun ve kondisyonun} öne çıkar.",
          "{○○ her oyunda adil oynar, kurallara uyar ve sportmenliğini korur|Her oyunda adil oynarsın, kurallara uyarsın ve sportmenliğini korursun}.",
          "Beden eğitimi açıkça {güçlü bir yönüdür|güçlü bir yönündür} ve {N} her etkinliğe tüm {çabasını verir|çabanı verirsin}."
        ]
      },
      "art": {
        "kw": "sanatsal yetenek",
        "lines": [
          "{N} resim ve sanat konusunda gerçek bir yeteneğe {sahiptir; çalışmaları yaratıcı ve renklidir|sahipsin; çalışmaların yaratıcı ve renklidir}.",
          "{○○ adlı öğrencimizin sanat çalışmaları|Sanat çalışmaların} hayal gücü ve özen gösterir.",
          "{N} sanat çalışmalarında renkleri ve detayları özenle {kullanır|kullanırsın}.",
          "{○○ adlı öğrencimizin sanat projeleri|Sanat projelerin} özgündür ve özenle tamamlanır.",
          "{○○ sanata hayal gücüyle ve yeni şeyler deneme isteğiyle yaklaşır|Sanata hayal gücüyle ve yeni şeyler deneme isteğiyle yaklaşırsın}.",
          "{○○ tarafından yapılan|Yaptığın} her sanat eserinde yaratıcılık parlıyor."
        ]
      },
      "music": {
        "kw": "müzik yeteneği",
        "lines": [
          "{N} müzik konusunda gerçek bir yetenek {gösteriyor ve derslere coşkuyla katılıyor|gösteriyorsun ve derslere coşkuyla katılıyorsun}.",
          "{○○ adlı öğrencimizin müzik kulağı çok iyi; şarkı söylemekten ve çalgı çalmaktan keyif alıyor|Müzik kulağın çok iyi; şarkı söylemekten ve çalgı çalmaktan keyif alıyorsun}.",
          "{N} özgüvenle şarkı {söylüyor ve ritmi çok iyi tutuyor|söylüyorsun ve ritmi çok iyi tutuyorsun}.",
          "{○○ adlı öğrencimizin müziğe olan coşkusu|Müziğe olan coşkun} derslerimize enerji katıyor.",
          "{○○ yeni şarkıları ve ritimleri hızla kavrar|Yeni şarkıları ve ritimleri hızla kavrıyorsun}.",
          "Müzik açıkça bir tutku ve {N} etkinliklere gerçek bir keyifle {katılıyor|katılıyorsun}."
        ]
      },
      "writing": {
        "kw": "güçlü yazma becerisi",
        "lines": [
          "{N} anlaşılır bir dille ve zengin bir hayal gücüyle {yazıyor|yazıyorsun}.",
          "{○○ adlı öğrencimizin yazıları|Yazıların} iyi düzenlenmiş olup zengin bir kelime dağarcığı sergiliyor.",
          "{N} yazılı çalışmalarında ilgi çekici kelimeler ve anlaşılır bir yapı {kullanıyor|kullanıyorsun}.",
          "{○○ adlı öğrencimizin hikayeleri|Hikayelerin} hayal gücüyle dolu ve okuması çok keyifli.",
          "{○○ fikirlerini yazıyla her geçen gün gelişen bir beceri ve ayrıntıyla ifade ediyor|Fikirlerini yazıyla her geçen gün gelişen bir beceri ve ayrıntıyla ifade ediyorsun}.",
          "Yazı yazmak {gerçekten güçlü bir yönü|senin gerçekten güçlü bir yönün}; {N} hikaye ve açıklamalar kurgulamaktan keyif {alıyor|alıyorsun}."
        ]
      },
      "creative": {
        "kw": "yaratıcılık",
        "lines": [
          "{N} projelere yaratıcı fikirler {katıyor ve uygulamalı etkinliklerden keyif alıyor|katıyorsun ve uygulamalı etkinliklerden keyif alıyorsun}.",
          "{○○ yaratıcı düşünür ve sorunlara özgün çözümler bulur|Yaratıcı düşünüyorsun ve sorunlara özgün çözümler buluyorsun}.",
          "{N} özgün fikirler {üretiyor; bir şeyler inşa etmekten ve tasarlamaktan keyif alıyor|üretiyorsun; bir şeyler inşa etmekten ve tasarlamaktan keyif alıyorsun}.",
          "{○○ adlı öğrencimizin hayal gücü|Hayal gücün} sınıf projelerine taze fikirler katıyor.",
          "{○○ denemeler yapmayı sever ve sorunları çözmek için yaratıcı yollar bulur|Denemeler yapmayı seviyorsun ve sorunları çözmek için yaratıcı yollar buluyorsun}.",
          "Uygulamalı projeler {○○ adlı öğrencimizin yaratıcılığını ve çözüm üretme becerisini|yaratıcılığını ve çözüm üretme becerini} ortaya çıkarıyor."
        ]
      },
      "stage": {
        "kw": "akıcı ve anlaşılır konuşma becerisi",
        "lines": [
          "{N} sınıfın önünde anlaşılır ve özgüvenli bir şekilde {konuşuyor|konuşuyorsun}.",
          "{○○ dinleyicilerin ilgisini çeken, ifade gücü yüksek bir konuşmacıdır|Dinleyicilerin ilgisini çeken, ifade gücü yüksek bir konuşmacısın}.",
          "{N} sınıfa net bir ses tonuyla ve iyi bir göz teması kurarak sunum {yapıyor|yapıyorsun}.",
          "{○○ adlı öğrencimizin sunumları|Sunumların} iyi hazırlanmış ve ilgi çekici.",
          "{○○ dinleyicilerin önünde özgüvenle konuşur ve fikirlerini anlaşılır biçimde açıklar|Dinleyicilerin önünde özgüvenle konuşuyorsun ve fikirlerini anlaşılır biçimde açıklıyorsun}.",
          "Topluluk önünde konuşmak {○○ için|senin için} çok doğal bir beceri."
        ]
      },
      "logic": {
        "kw": "mantıksal düşünme",
        "lines": [
          "{N} mantıksal {düşünüyor ve problemleri birden fazla yolla çözüyor|düşünüyorsun ve problemleri birden fazla yolla çözüyorsun}.",
          "{○○ zorlayıcı problemlerden keyif alır ve net bir şekilde akıl yürütür|Zorlayıcı problemlerden keyif alıyorsun ve net bir şekilde akıl yürütüyorsun}.",
          "{N} problemleri adım adım {çözümlüyor ve akıl yürütme sürecini anlaşılır biçimde açıklıyor|çözümlüyorsun ve akıl yürütme sürecini anlaşılır biçimde açıklıyorsun}.",
          "{○○ adlı öğrencimizin mantıksal düşünme becerisi|Mantıksal düşünme becerin} bulmacalarda ve zorlayıcı görevlerde öne çıkıyor.",
          "{○○ örüntüleri hızla fark eder ve çözüm bulmak için bunları kullanır|Örüntüleri hızla fark ediyorsun ve çözüm bulmak için bunları kullanıyorsun}.",
          "Zor sorularda akıl yürüterek çözüme ulaşmak {○○ adlı öğrencimizin|senin} en güçlü yönlerinden biri."
        ]
      },
      "prog_study": {
        "kw": "belirgin akademik gelişim",
        "lines": [
          "{N} bu dönem mükemmel bir akademik gelişim {gösterdi|gösterdin}.",
          "{○○ adlı öğrencimizin sıkı çalışması|Sıkı çalışman}, istikrarlı ve gözle görülür bir gelişimle karşılığını verdi.",
          "{○○ adlı öğrencimizin çalışmaları|Çalışmaların} bu dönem tüm derslerde istikrarlı bir şekilde gelişti.",
          "{N} geçtiğimiz aylarda bir öğrenci olarak gözle görülür biçimde {gelişti|geliştin}.",
          "{○○ adlı öğrencimizin bu dönem sınıfta elde ettiği|Bu dönem sınıfta elde ettiğin} kazanımlar açıkça görülüyor.",
          "{○○ becerilerini güçlendirdi ve artık daha zor çalışmaları başarıyla tamamlıyor|Becerilerini güçlendirdin ve artık daha zor çalışmaları başarıyla tamamlıyorsun}."
        ]
      },
      "prog_confidence": {
        "kw": "artan özgüven",
        "lines": [
          "{N} özgüven {kazandı ve artık fikirlerini daha rahat paylaşıyor|kazandın ve artık fikirlerini daha rahat paylaşıyorsun}.",
          "Bu dönem {○○ adlı öğrencimizin daha özgüvenli hale geldiğini|daha özgüvenli hale geldiğini} görmek harikaydı.",
          "{N} dönem başına göre artık derslere daha istekli {katılıyor|katılıyorsun}.",
          "{○○ adlı öğrencimizin artan özgüveni|Artan özgüvenin}, yeni şeyler deneme biçiminde kendini gösteriyor.",
          "{○○ söz alıp fikirlerini paylaşmaya daha istekli hale geldi|Söz alıp fikirlerini paylaşmaya daha istekli hale geldin}.",
          "{○○ adlı öğrencimizin çalışmalarında ve derse katılımında|Çalışmalarında ve derse katılımında} yeni bir özgüven açıkça görülüyor."
        ]
      },
      "prog_habit": {
        "kw": "gelişen günlük alışkanlıklar",
        "lines": [
          "{N} rutinlere uyma ve davranışlarını bağımsız olarak yönetme konusunda büyük ilerleme {kaydetti|kaydettin}.",
          "{○○ odaklanma ve çalışma alışkanlıklarını|Odaklanma ve çalışma alışkanlıklarını} gözle görülür biçimde {geliştirdi|geliştirdin}.",
          "{N} artık günlük rutinleri çok daha bağımsız bir şekilde takip {ediyor|ediyorsun}.",
          "{○○ düzenini ve derslere hazırlığını|Düzenini ve derslere hazırlığını} büyük ölçüde {geliştirdi|geliştirdin}.",
          "{○○ dersler|Dersler} sırasında daha sakin ve odaklı hale {geldi|geldin}.",
          "Gelişen alışkanlıklar, {○○ için her|her} okul gününden daha fazla verim {alınmasına|almana} yardımcı oldu."
        ]
      },
      "prog_social": {
        "kw": "güçlenen arkadaşlıklar",
        "lines": [
          "{N} sosyal açıdan {gelişti ve artık sınıf arkadaşlarıyla çok iyi anlaşıyor|geliştin ve artık sınıf arkadaşlarınla çok iyi anlaşıyorsun}.",
          "{○○ duygularını|Duygularını} sakin bir şekilde ifade etmeyi ve başkalarıyla uyumlu çalışmayı {öğrendi|öğrendin}.",
          "{N} artık ikili ve grup çalışmalarında sınıf {arkadaşlarıyla|arkadaşlarınla} daha rahat {çalışıyor|çalışıyorsun}.",
          "{○○ farklı sınıf arkadaşlarıyla olan uyumunu|Farklı sınıf arkadaşlarınla olan uyumunu} dönem boyunca {geliştirdi|geliştirdin}.",
          "{○○ başkalarına|Başkalarına} karşı daha sabırlı ve anlayışlı hale {geldi|geldin}.",
          "Bu dönem sınıf arkadaşlarıyla anlaşmak {○○ için|senin için} çok daha kolay hale geldi."
        ]
      },
      "a_concept": {
        "kw": "sağlam bir {c} kavrayışı",
        "lines": [
          "{subj} dersinde, {N} {c} konusunda sağlam bir anlayış {sergiliyor|sergiliyorsun}.",
          "{N} {subj} dersindeki yeni fikirleri hızlı ve doğru bir şekilde {kavrıyor|kavrıyorsun}.",
          "{N} {c} konusunu iyi {anlıyor ve ana fikirleri açıklayabiliyor|anlıyorsun ve ana fikirleri açıklayabiliyorsun}.",
          "{c} konusundaki {anlayışı, ○○ için|anlayışın} sağlam ve gelişmeye devam ediyor.",
          "{subj} dersinde yeni konular işlendiğinde, {N} bunları önceden {bildikleriyle ilişkilendiriyor|bildiklerinle ilişkilendiriyorsun}.",
          "{○○|Sen} {subj} dersindeki temel kavramları net bir şekilde {kavramış durumda|kavramış durumdasın}."
        ]
      },
      "a_skill": {
        "kw": "özgüvenli {k}",
        "lines": [
          "{N} {k} alanında gelişen bir beceri {sergiliyor|sergiliyorsun}.",
          "{○○|Sen} güçlü ve istikrarlı {k} becerilerine {sahip|sahipsin}.",
          "{N} {k} konusunda özgüven {kazanıyor|kazanıyorsun}.",
          "{k} alanında {○○ tarafından kaydedilen gelişim|kaydettiğin gelişim} sınıfta açıkça görülüyor.",
          "{N} {k} çalışmalarına gerçek bir çaba {gösteriyor|gösteriyorsun}.",
          "{N} {k} içeren görevleri giderek artan bir rahatlıkla {yerine getiriyor|yerine getiriyorsun}."
        ]
      },
      "a_apply": {
        "kw": "öğrendiklerini uygulama",
        "lines": [
          "{N} {subj} dersinde {öğrendiklerini|öğrendiğin bilgileri} yeni durumlara kolaylıkla {uyguluyor|uyguluyorsun}.",
          "{N} {subj} dersi ile günlük yaşam arasında güzel bağlantılar {kuruyor|kuruyorsun}.",
          "{N} yeni görevlerin üstesinden gelmek için {subj} dersinde {öğrendiklerini kullanıyor|öğrendiklerini kullanıyorsun}.",
          "{○○|Sen} {subj} dersindeki fikirleri alıp yeni yollarla {kullanabiliyor|kullanabiliyorsun}.",
          "{N} {subj} dersinde öğrenilenleri sık sık gerçek hayatla {ilişkilendiriyor|ilişkilendiriyorsun}.",
          "{N} {subj} dersinde {edindiği|edindiğin} yeni becerileri pratik yollarla {uyguluyor|uyguluyorsun}."
        ]
      },
      "a_express": {
        "kw": "anlaşılır açıklamalar",
        "lines": [
          "{N} {subj} tartışmaları sırasında {fikirlerini|fikirlerini} anlaşılır bir şekilde {açıklıyor|açıklıyorsun}.",
          "{N} {subj} derslerinde fikirlerini özgüvenle {paylaşıyor|paylaşıyorsun}.",
          "{N} {subj} dersindeki fikirlerini hem sözlü hem de yazılı olarak net bir biçimde ifade {ediyor|ediyorsun}.",
          "{○○|Sen} {subj} derslerinde düşüncelerini {paylaşıyor ve başkalarının görüşlerini dinliyor|paylaşıyorsun ve başkalarının görüşlerini dinliyorsun}.",
          "{subj} tartışmalarına {○○ tarafından yapılan katkılar|yaptığın katkılar} özenli ve anlaşılır.",
          "{subj} dersinde, {N} fikirlerini ifade etmek için doğru kelimeleri {kullanıyor|kullanıyorsun}."
        ]
      },
      "a_explore": {
        "kw": "derinlemesine sorgulama",
        "lines": [
          "{N} {subj} dersinde düşündürücü sorular {soruyor ve fikirleri keşfediyor|soruyorsun ve fikirleri keşfediyorsun}.",
          "{N} problem çözerken farklı stratejiler {deniyor|deniyorsun}.",
          "{N} {subj} dersinde soruları araştırmaktan ve yanıtlar aramaktan keyif {alıyor|alıyorsun}.",
          "{○○|Sen} {subj} dersindeki {merakı sayesinde düşündürücü sorular soruyor|merakın sayesinde düşündürücü sorular soruyorsun}.",
          "{○○ fikirleri|Fikirleri} test etmeye ve sonuçlarından öğrenmeye {istekli|isteklisin}.",
          "{subj} dersinde, {N} dikkatle {düşünüyor ve sorulara farklı açılardan yaklaşıyor|düşünüyorsun ve sorulara farklı açılardan yaklaşıyorsun}."
        ]
      },
      "a_work": {
        "kw": "özenli {w}",
        "lines": [
          "{○○|Sen} {w} çalışmalarını eksiksiz ve özenle {tamamlıyor|tamamlıyorsun}.",
          "{N} {w} çalışmalarını eksiksiz tamamlamaya özen {gösteriyor|gösteriyorsun}.",
          "{N} {w} çalışmalarını düzenli ve zamanında {tamamlıyor|tamamlıyorsun}.",
          "{○○|Sen} {w} çalışmalarında özen ve ayrıntılara dikkat {gösteriyor|gösteriyorsun}.",
          "{○○ eksiksiz|Eksiksiz} ve özenle sunulmuş {w} çalışmaları ortaya koymaktan gurur {duyuyor|duyuyorsun}.",
          "{○○ tarafından teslim edilen|Teslim ettiğin} {w} çalışmaları her zaman eksiksiz ve özenli."
        ]
      },
      "a_engage": {
        "kw": "istekli katılım",
        "lines": [
          "{N} {subj} derslerinde ilgili ve {coşkulu|coşkulusun}.",
          "{N} {subj} dersine gerçek bir ilgi {gösteriyor|gösteriyorsun}.",
          "{N} {subj} etkinliklerine hevesle {katılıyor|katılıyorsun}.",
          "{○○|Sen} her derste {subj} dersine olan {heyecanını açıkça gösteriyor|heyecanını açıkça gösteriyorsun}.",
          "{○○|Sen} {subj} derslerine enerjik ve olumlu bir tutumla {katılıyor|katılıyorsun}.",
          "{N} {subj} derslerini dört gözle {bekliyor ve ders boyunca ilgisini koruyor|bekliyorsun ve ders boyunca ilgini koruyorsun}."
        ]
      },
      "a_improve": {
        "kw": "istikrarlı gelişim",
        "lines": [
          "{N} bu dönem {subj} dersinde istikrarlı bir gelişim {gösterdi|gösterdin}.",
          "{○○|Sen} {subj} dersindeki sonuçlarını geliştirmeye devam {ediyor|ediyorsun}.",
          "{○○ adlı öğrencimizin|Senin} {subj} dersindeki {becerileri|becerilerin} bu dönem istikrarlı bir şekilde gelişti.",
          "{N} düzenli {çabası|çaban} sayesinde {subj} dersinde belirgin kazanımlar elde {etti|ettin}.",
          "Dönem boyunca {○○|sen} {subj} dersinde daha özgüvenli hale {geldi|geldin}.",
          "{N} her ay {subj} dersinde önceki {öğrendiklerinin|öğrendiklerinin} üzerine yenilerini {ekliyor|ekliyorsun}."
        ]
      }
    },
    "wishes": {
      "w_focus": [
        "{○○ için|Senin için} bir sonraki adım, dersler sırasında {odağını|odağını} korumaktır; bu sayede öğrenme süreci çok daha verimli hale gelecektir.",
        "{○○ adlı öğrencimizin dikkatini|Dikkatini} derste {tutmasını|tutmanı} ve dikkat dağıtıcı unsurları bir kenara {bırakmasını|bırakmanı} teşvik ediyorum.",
        "Konuşmacıyı izlemek gibi etkin dinleme çalışmaları yapmak, {○○ adlı öğrencimizin her|her} önemli fikri {yakalamasına|yakalamana} yardımcı olacaktır.",
        "Daha kolay odaklanabilmek için {○○ adlı öğrencimizin sırada|sırada} yalnızca gerekli malzemeleri {bulundurmasını|bulundurmanı} öneriyorum.",
        "Bireysel çalışmalar sırasında odaklanmayı geliştirmeye devam etmek, {○○ adlı öğrencimizin görevleri|görevleri} özgüvenle {tamamlamasına|tamamlamana} yardımcı olacaktır."
      ],
      "w_careful": [
        "Çalışmaları teslim etmeden önce kontrol etmek için kısa bir süre ayırmak, {○○ adlı öğrencimizin küçük|küçük} hataları {önlemesine|önlemene} yardımcı olacaktır.",
        "{○○ için|Senin için} bir sonraki adım, biraz yavaşlayıp yanıtları ikinci kez kontrol etmektir.",
        "Yanıtlamadan önce her soruyu iki kez okumak, {○○ adlı öğrencimizin küçük|küçük} hataları fark {etmesine|etmene} yardımcı olacaktır.",
        "{Çalışmasını|Çalışmanı} teslim etmeden önce {○○ adlı öğrencimizin kısa|kısa} bir kontrol listesi {kullanmasını|kullanmanı} öneriyorum.",
        "Her görevin sonunda yanıtları gözden geçirmek için zaman ayırmak, {○○ adlı öğrencimizin çalışmalarını|çalışmalarını} daha da hatasız hale getirecektir."
      ],
      "w_homework": [
        "Düzenli bir ödev rutini oluşturmak, {○○ adlı öğrencimizin ödevlerini|ödevlerini} zamanında teslim {etmesine|etmene} yardımcı olacaktır.",
        "Hiçbir şeyin gözden kaçmaması için {○○ adlı öğrencimizin her|her} gün ödev listesini kontrol {etmesini|etmeni} öneriyorum.",
        "Ödevleri ev ile okul arasında taşımak için bir ödev dosyası kullanmak, her şeyin düzenli ilerlemesine yardımcı olacaktır.",
        "{○○ için|Senin için} bir sonraki adım, her gün ödevlere aynı saatte başlamaktır.",
        "Tamamlanan ödevleri bir gece önceden çantaya koymak, ödevlerin okula zamanında ulaşmasına yardımcı olacaktır."
      ],
      "w_handwriting": [
        "Yazarken biraz yavaşlamak, {○○ adlı öğrencimizin el yazısının|el yazının} daha düzenli ve okunaklı olmasına yardımcı olacaktır.",
        "Bir sonraki adım, el yazısına ve sayfa düzenine daha fazla özen göstermektir.",
        "Günde birkaç dakika harf yazım pratiği yapmak, {○○ adlı öğrencimizin yazısının|yazının} daha düzenli görünmesine yardımcı olacaktır.",
        "{○○ adlı öğrencimizin kelimeler|Kelimeler} arasında net boşluklar {bırakmasını|bırakmanı} ve harfleri satır çizgisinde {tutmasını|tutmanı} öneriyorum.",
        "Sayfa düzenine biraz daha zaman ayırmak, {○○ adlı öğrencimizin güzel fikirlerinin|güzel fikirlerinin} öne çıkmasına yardımcı olacaktır."
      ],
      "w_speak": [
        "{○○ adlı öğrencimizin düşünceleri|Düşüncelerin} çok değerli olduğu için sınıfta fikirlerini daha sık {paylaşmasını|paylaşmanı} teşvik ediyorum.",
        "Bir sonraki adım, daha sık parmak kaldırmak ve sınıf tartışmalarına katılmaktır.",
        "Fikirleri önce bir sıra arkadaşıyla paylaşarak pratik yapmak, {○○ adlı öğrencimizin tüm|tüm} sınıfla paylaşmaya hazır {hissetmesine|hissetmene} yardımcı olacaktır.",
        "{○○ adlı öğrencimizin her|Her} tartışmada en az bir kez katkıda bulunmak gibi küçük bir hedef {belirlemesini|belirlemeni} öneriyorum.",
        "{○○ adlı öğrencimizin düşüncelerini|Düşüncelerini} daha sık sesli olarak paylaşmak, sınıf arkadaşlarının da {○○ adlı öğrencimizden|senden} öğrenmesine yardımcı olacaktır."
      ],
      "w_emotion": [
        "{○○ için|Senin için} bir sonraki adım, üzüldüğünde derin bir nefes almak ve duygularını kelimelerle ifade etmektir.",
        "Sakinleşme yöntemlerini uygulamak, {○○ adlı öğrencimizin hayal|hayal} kırıklığıyla başa {çıkmasına|çıkmana} yardımcı olacaktır.",
        "Duyguları sesli olarak dile getirmek, {○○ adlı öğrencimizin doğru|doğru} desteği hızla {almasına|almana} yardımcı olacaktır.",
        "İşler zorlaştığında {○○ adlı öğrencimizin kısa|kısa} bir mola verip beşe kadar {saymasını|saymanı} öneriyorum.",
        "Bir sonraki adım, yavaş nefes almak gibi hayal kırıklığıyla sakin bir şekilde başa çıkma yollarını uygulamaktır."
      ],
      "w_friends": [
        "Anlaşmazlıklar yaşandığında {○○ adlı öğrencimizin başkalarının|başkalarının} fikirlerini {dinlemesini|dinlemeni} ve nazik kelimeler {kullanmasını|kullanmanı} öneriyorum.",
        "Sınıf arkadaşlarına karşı sabırlı olma pratiğine devam etmek, arkadaşlıkların gelişmesine yardımcı olacaktır.",
        "Grup çalışmalarında ve oyunlarda {○○ adlı öğrencimizin farklı|farklı} sınıf arkadaşlarını da katılmaya davet {etmesini|etmeni} teşvik ediyorum.",
        "Sırayla yapma ve paylaşma pratiği yapmak, {○○ adlı öğrencimizin arkadaşlıklarının|arkadaşlıklarının} daha da güçlenmesine yardımcı olacaktır.",
        "{○○ için|Senin için} bir sonraki adım, anlaşmazlıkları sakin bir şekilde konuşarak çözmek ve adil bir çözüm aramaktır."
      ],
      "w_tidy": [
        "Her gün {○○ adlı öğrencimizin sırasını ve çantasını|sıranı ve çantanı} toplamak için bir dakika ayırmak, derslerin daha akıcı geçmesini sağlayacaktır.",
        "Bir sonraki adım, malzemeleri düzenli ve derse hazır tutmaktır.",
        "Basit bir gün sonu kontrol listesi kullanmak, {○○ adlı öğrencimizin malzemelerini|malzemelerini} düzenli {tutmasına|tutmana} yardımcı olacaktır.",
        "{○○ adlı öğrencimizin kullandığı|Kullandığın} her eşyayı hemen sonrasında yerine {koymasını|koymanı} öneriyorum.",
        "Bir sonraki adım, kağıtların kolayca bulunabilmesi için dosyaları düzenli tutmaktır."
      ],
      "w_reading": [
        "Her gün on dakika kitap okumak, {○○ adlı öğrencimizin kelime dağarcığını ve okuduğunu anlama becerisini geliştirmesine|kelime dağarcığını ve okuduğunu anlama becerini geliştirmene} yardımcı olacaktır.",
        "{○○ adlı öğrencimizin evde daha fazla kitap keşfetmesini|Evde daha fazla kitap keşfetmeni} teşvik ediyorum.",
        "Çoğu gün birkaç dakika sesli okuma yapmak, akıcılığı ve özgüveni geliştirmeye yardımcı olacaktır.",
        "{○○ adlı öğrencimizin kurgu dışı veya şiir gibi yeni türlerden kitaplar denemesini|Kurgu dışı veya şiir gibi yeni türlerden kitaplar denemeni} teşvik ediyorum.",
        "Her kitabı okuduktan sonra üzerine konuşmak, {○○ adlı öğrencimizin okuduklarını daha derinlemesine anlamasına|okuduklarını daha derinlemesine anlamana} yardımcı olacaktır."
      ],
      "w_initiative": [
        "{○○ için bir sonraki adım|Senin için bir sonraki adım}, bir şey net olmadığında hemen yardım istemektir.",
        "Öğrenme sürecinde daha fazla inisiyatif almak, {○○ adlı öğrencimizin bir üst seviyeye ulaşmasına|bir üst seviyeye ulaşmana} yardımcı olacaktır.",
        "{○○ adlı öğrencimizin merak ettiği her konuda soru sormasını|Merak ettiğin her konuda soru sormanı} teşvik ediyorum.",
        "Görevlere bağımsız olarak başlamak için ilk adımı atmak, {○○ adlı öğrencimizin öğrenme yolculuğunda gelişmesine|öğrenme yolculuğunda gelişmene} yardımcı olacaktır.",
        "Bir sonraki adım, sınıf çalışmalarını bitirdikten sonra ek bir görev aramaktır."
      ],
      "w_rules": [
        "{○○ adlı öğrencimizin sırasını beklemek ve sabırlı olmak gibi sınıf rutinlerine uymaya devam etmesini|Sıranı beklemek ve sabırlı olmak gibi sınıf rutinlerine uymaya devam etmeni} teşvik ediyorum.",
        "Bir sonraki adım, gün boyunca sınıf kurallarını hatırlamaktır.",
        "Etkinlik geçişleri sırasında sınıf kurallarına uymaya devam etmek, günün sorunsuz ilerlemesine yardımcı olacaktır.",
        "{○○ adlı öğrencimizin durup seçimlerinin başkalarını nasıl etkilediğini düşünmesini|Durup seçimlerinin başkalarını nasıl etkilediğini düşünmeni} teşvik ediyorum.",
        "Konuşmak için sırayı beklemeyi alışkanlık edinmek, {○○ adlı öğrencimizin sınıf arkadaşlarına saygı göstermesine|sınıf arkadaşlarına saygı göstermene} yardımcı olacaktır."
      ],
      "w_confidence": [
        "Hatalar öğrenmenin bir parçası olduğu için {○○ adlı öğrencimizin yeni zorlukları cesurca denemesini|yeni zorlukları cesurca denemeni} teşvik ediyorum.",
        "Bir sonraki adım, {○○ adlı öğrencimizin kendi yeteneklerine biraz daha fazla güvenmesidir|kendine biraz daha fazla güvenmendir}.",
        "Her hafta yeni bir zorluğun üstesinden gelmek, {○○ adlı öğrencimizin özgüven kazanmasına|özgüven kazanmana} yardımcı olacaktır.",
        "{○○ adlı öğrencimizin küçük başarıları kutlamasını ve en önemli şeyin çaba olduğunu hatırlamasını|Küçük başarıları kutlamanı ve en önemli şeyin çaba olduğunu hatırlamanı} teşvik ediyorum.",
        "Bir sonraki adım, desteğin her zaman orada olduğunu bilerek ara sıra daha zor olan seçeneği denemektir."
      ],
      "w_time": [
        "Ödevleri ve tekrarları planlamak için basit bir çizelge kullanmak, {○○ adlı öğrencimizin kendini daha az telaşlı hissetmesine|kendini daha az telaşlı hissetmene} yardımcı olacaktır.",
        "Bir sonraki adım, zamanı planlama ve görevleri önceliklendirme pratiği yapmaktır.",
        "Büyük görevleri daha küçük adımlara bölmek, {○○ adlı öğrencimizin plana sadık kalmasına|plana sadık kalmana} yardımcı olacaktır.",
        "{○○ adlı öğrencimizin uzun ödevleri son dakikaya bırakmak yerine erken başlamasını|Uzun ödevleri son dakikaya bırakmak yerine erken başlamanı} teşvik ediyorum.",
        "Çalışma sırasında zamanlayıcı kullanmak, {○○ adlı öğrencimizin odaklanmasına|odaklanmana} yardımcı olacaktır."
      ]
    },
    "areas": {
      "chinese": {
        "subj": "Türkçe",
        "c": "okuma ve kelime bilgisi",
        "k": "okuma ve yazma",
        "w": "yazılı çalışmalar"
      },
      "math": {
        "subj": "Matematik",
        "c": "sayılar ve geometri kavramları",
        "k": "hesaplama ve problem çözme",
        "w": "alıştırma çalışmaları"
      },
      "english": {
        "subj": "İngilizce",
        "c": "kelime bilgisi ve cümle kalıpları",
        "k": "dinleme ve konuşma",
        "w": "İngilizce ödevi"
      },
      "social": {
        "subj": "Sosyal Bilgiler",
        "c": "toplum ve tarih konuları",
        "k": "araştırma ve sunum",
        "w": "proje çalışmaları"
      },
      "science": {
        "subj": "Fen Bilimleri",
        "c": "temel fen kavramları",
        "k": "gözlem ve deneyler",
        "w": "laboratuvar çalışmaları"
      },
      "arts": {
        "subj": "Görsel Sanatlar ve Müzik",
        "c": "temel sanat ve müzik kavramları",
        "k": "üretim ve sergileme",
        "w": "sanat çalışmaları"
      },
      "pe": {
        "subj": "Beden Eğitimi ve Sağlık",
        "c": "sağlıklı yaşam",
        "k": "fiziksel beceriler",
        "w": "beden eğitimi ve sağlık çalışmaları"
      },
      "integrative": {
        "subj": "Yaşam Becerileri",
        "c": "öz farkındalık ve yaşam becerileri",
        "k": "grup etkinlikleri",
        "w": "etkinlik çalışmaları"
      },
      "life": {
        "subj": "Hayat Bilgisi",
        "c": "çevremizdeki dünya",
        "k": "gözlem ve uygulama",
        "w": "proje çalışmaları"
      }
    },
    "frames": {
      "openings": [
        {
          "t": "Bu dönem ○○ adlı öğrencimizin sınıfımızda olması büyük bir mutluluktu.",
          "u": [
            "term"
          ],
          "p": "parent",
          "tone": "warm"
        },
        {
          "t": "○○ harika bir dönem geçirdi.",
          "u": [
            "term"
          ],
          "p": "parent",
          "tone": "warm"
        },
        {
          "t": "○○ için ne kadar da harika bir dönem oldu!",
          "u": [
            "term"
          ],
          "p": "parent",
          "tone": "warm"
        },
        {
          "t": "Bu dönem seni sınıfımızda görmek büyük bir mutluluktu.",
          "u": [
            "term"
          ],
          "p": "child",
          "tone": "warm"
        },
        {
          "t": "○○, harika bir dönem geçirdin!",
          "u": [
            "term"
          ],
          "p": "child",
          "tone": "warm"
        },
        {
          "t": "○○ başarılı bir dönem geçirdi.",
          "u": [
            "term"
          ],
          "p": "parent",
          "tone": "formal"
        },
        {
          "t": "{○○ bu dönem|Bu dönem} istikrarlı bir gelişim {gösterdi|gösterdin}.",
          "u": [
            "term"
          ],
          "tone": "formal"
        },
        {
          "t": "{○○ bu dönem|Bu dönem} giderek artan bir olgunluk {sergiledi|sergiledin}.",
          "u": [
            "term"
          ],
          "g": [
            "high"
          ]
        },
        {
          "t": "{○○ son zamanlarda|Son zamanlarda} sınıfta çok iyi {gidiyor|gidiyorsun}.",
          "u": [
            "brief"
          ]
        },
        {
          "t": "○○ hakkında güzel haberler paylaşmak istedim.",
          "u": [
            "brief",
            "cheer"
          ],
          "p": "parent",
          "tone": "warm"
        },
        {
          "t": "○○, bugün harika iş çıkardın!",
          "u": [
            "cheer"
          ],
          "p": "child"
        },
        {
          "t": "○○, bugün harika bir şey fark ettim!",
          "u": [
            "cheer"
          ],
          "p": "child",
          "tone": "warm"
        },
        {
          "t": "{○○ bu dönem|Bu dönem} dikkate değer bir ilerleme {kaydetti|kaydettin}.",
          "u": [
            "special"
          ],
          "f": "progress"
        },
        {
          "t": "Bu dönem {○○ için|senin için} ne büyük bir fark yarattı!",
          "u": [
            "special"
          ],
          "f": "progress",
          "tone": "warm"
        },
        {
          "t": "Her çocuk farklı bir hızda öğrenir ve ○○ istikrarlı bir şekilde gelişiyor.",
          "u": [
            "special"
          ],
          "f": "support",
          "p": "parent"
        },
        {
          "t": "Herkes farklı bir hızda öğrenir ve sen istikrarlı bir şekilde gelişiyorsun.",
          "u": [
            "special"
          ],
          "f": "support",
          "p": "child"
        },
        {
          "t": "{○○ dolu dolu|Dolu dolu} ve verimli bir dönem {geçirdi|geçirdin}.",
          "u": [
            "term"
          ]
        },
        {
          "t": "Bu dönem {○○ için|senin için} gerçek bir gelişim dönemi oldu.",
          "u": [
            "term"
          ]
        },
        {
          "t": "Bu dönem {○○ adlı öğrencimize|sana} öğretmenlik yapmak gerçek bir mutluluktu.",
          "u": [
            "term"
          ],
          "tone": "warm"
        },
        {
          "t": "Bu dönem {○○ adlı öğrencimizi|seni} tanımaktan büyük keyif aldım.",
          "u": [
            "term"
          ],
          "tone": "warm"
        },
        {
          "t": "{○○ bu dönemin|Bu dönemin} çalışmalarını giderek artan bir bağımsızlıkla {yürüttü|yürüttün}.",
          "u": [
            "term"
          ],
          "g": [
            "high"
          ]
        },
        {
          "t": "Bu rapor, {○○ adlı öğrencimizin bu dönemki gelişimini|bu dönemki gelişimini} ve güçlü yönlerini özetlemektedir.",
          "u": [
            "term"
          ],
          "tone": "formal"
        },
        {
          "t": "İşte {○○ adlı öğrencimizin durumu|nasıl gittiğin} hakkında kısa bir bilgilendirme.",
          "u": [
            "brief"
          ]
        },
        {
          "t": "{○○ sınıfta|Sınıfta} güzel birkaç hafta {geçirdi|geçirdin}.",
          "u": [
            "brief"
          ]
        },
        {
          "t": "Sınıfta {○○ için|senin için} işler yolunda gidiyor.",
          "u": [
            "brief"
          ],
          "tone": "warm"
        },
        {
          "t": "○○ hakkında paylaşmak istediğim birkaç güzel söz var.",
          "u": [
            "cheer"
          ],
          "p": "parent"
        },
        {
          "t": "○○ adlı öğrencimizi kutlamak için küçük bir not.",
          "u": [
            "cheer"
          ],
          "p": "parent",
          "tone": "warm"
        },
        {
          "t": "○○ övgüyü hak ediyor.",
          "u": [
            "cheer"
          ],
          "p": "parent"
        },
        {
          "t": "○○, işte sadece senin için bir not.",
          "u": [
            "cheer"
          ],
          "p": "child"
        },
        {
          "t": "○○, kendinle gurur duymalısın.",
          "u": [
            "cheer"
          ],
          "p": "child"
        },
        {
          "t": "Aferin ○○!",
          "u": [
            "cheer"
          ],
          "p": "child"
        },
        {
          "t": "{○○ adlı öğrencimizin bu dönemki gelişimi|Bu dönemki gelişimin} açıkça görülüyor.",
          "u": [
            "special"
          ],
          "f": "progress"
        },
        {
          "t": "Bu dönem, {○○ için|senin için} gerçek bir ilerleme dönemi oldu.",
          "u": [
            "special"
          ],
          "f": "progress"
        },
        {
          "t": "{○○ bu dönem|Bu dönem} ileriye doğru önemli adımlar {attı|attın}.",
          "u": [
            "special"
          ],
          "f": "progress"
        },
        {
          "t": "{○○ adım adım,|Adım adım,} rahat bir tempoda ilerleme {kaydediyor|kaydediyorsun}.",
          "u": [
            "special"
          ],
          "f": "support"
        },
        {
          "t": "Öğrenmek zaman alır ve {○○ becerilerini|becerilerini} istikrarlı bir şekilde {geliştiriyor|geliştiriyorsun}.",
          "u": [
            "special"
          ],
          "f": "support"
        },
        {
          "t": "{○○ adlı öğrencimizin bu dönem|Bu dönem} neleri iyi yaptığını paylaşmaktan mutluluk duyuyorum.",
          "u": [
            "special"
          ],
          "f": "support",
          "tone": "warm"
        }
      ],
      "fillers": [
        {
          "t": "Bu aylar boyunca {○○ adlı öğrencimizin gelişimini|gelişimini} izlemek çok güzeldi.",
          "u": [
            "term",
            "special"
          ],
          "tone": "warm"
        },
        {
          "t": "Bu özellikler, {○○ adlı öğrencimizi|seni} sınıfımızın değerli bir üyesi yapıyor.",
          "u": [
            "term",
            "brief"
          ]
        },
        {
          "t": "Evdeki desteğiniz için teşekkür ederim.",
          "u": [
            "term",
            "brief",
            "special"
          ],
          "p": "parent"
        },
        {
          "t": "Genel olarak, {○○ adlı öğrencimizin bu dönemki performansı|bu dönemki performansın} istikrarlıydı.",
          "u": [
            "term"
          ],
          "tone": "formal"
        },
        {
          "t": "Bu ilerleme, düzenli günlük çabanın sonucudur.",
          "u": [
            "special"
          ],
          "f": "progress"
        },
        {
          "t": "Düzenli çalışmaya devam ettikçe {○○ adlı öğrencimizin sonuçlarını göreceğine|sonuçlarını göreceğine} eminim.",
          "u": [
            "special"
          ],
          "f": "support"
        },
        {
          "t": "Okulda {○○ adlı öğrencimizi|seni} desteklemeye devam edeceğim.",
          "u": [
            "special"
          ],
          "f": "support"
        },
        {
          "t": "{○○ bu dönem|Bu dönem} istikrarlı bir şekilde {çalıştı|çalıştın}.",
          "u": [
            "subject"
          ]
        },
        {
          "t": "Bu alandaki genel ilerleme iyi düzeydedir.",
          "u": [
            "subject"
          ],
          "tone": "formal"
        },
        {
          "t": "{○○,|Sen,} {subj} derslerine iyi katılım {sağlıyor|sağlıyorsun} ve sınıf çalışmalarını {tamamlıyor|tamamlıyorsun}.",
          "u": [
            "subject"
          ]
        },
        {
          "t": "{○○,|Sen,} {subj} alanında istikrarlı beceriler {geliştiriyor|geliştiriyorsun}.",
          "u": [
            "subject"
          ]
        },
        {
          "t": "Çabaların gözden kaçmıyor.",
          "u": [
            "cheer",
            "brief"
          ],
          "p": "child"
        },
        {
          "t": "{○○ sınıfımızın|Sınıfımızın} rutinlerine iyi uyum {sağladı|sağladın} ve her güne olumlu bir tutumla {yaklaşıyor|yaklaşıyorsun}.",
          "u": [
            "term",
            "special"
          ]
        },
        {
          "t": "{○○ bu dönem|Bu dönem} sınıf ortamımıza çok büyük katkıda {bulundu|bulundun}.",
          "u": [
            "term"
          ]
        },
        {
          "t": "Dönem boyunca {○○ adlı öğrencimizin güçlü yönlerinin|güçlü yönlerinin} geliştiğini görmek büyük bir mutluluktu.",
          "u": [
            "term",
            "special"
          ],
          "tone": "warm"
        },
        {
          "t": "Dönem boyunca {○○ istikrarlı|istikrarlı} ve olumlu bir çabayla beklentileri {karşıladı|karşıladın}.",
          "u": [
            "term",
            "special"
          ],
          "tone": "formal"
        },
        {
          "t": "{○○ bir öğrenci|Bir öğrenci} ve sınıfın bir üyesi olarak gelişmeye devam {ediyor|ediyorsun}.",
          "u": [
            "term",
            "special",
            "brief"
          ]
        },
        {
          "t": "{○○ her okul gününe|Her okul gününe} istekli bir tutumla {yaklaşıyor|yaklaşıyorsun}.",
          "u": [
            "term",
            "special",
            "brief"
          ]
        },
        {
          "t": "{○○ sınıfımızda|Sınıfımızda} istikrarlı ve güvenilir bir birey haline {geldi|geldin}.",
          "u": [
            "term",
            "brief"
          ]
        },
        {
          "t": "{○○ adlı öğrencimizin her gün gösterdiği|Her gün gösterdiğin} çaba açıkça görülüyor.",
          "u": [
            "term",
            "special",
            "brief"
          ]
        },
        {
          "t": "{○○ hem sınıf arkadaşlarıyla hem de öğretmenleriyle iyi ilişkiler kurdu|Hem sınıf arkadaşlarınla hem de öğretmenlerinle iyi ilişkiler kurdun}.",
          "u": [
            "term",
            "special"
          ]
        },
        {
          "t": "{○○ adlı öğrencimizin okulda başarılı olmayı önemsediği|Okulda başarılı olmayı önemsediğin} çok açık.",
          "u": [
            "term",
            "special"
          ]
        },
        {
          "t": "Dönem ilerledikçe {○○ bağımsız çalışma konusunda gelişim gösterdi|bağımsız çalışma konusunda gelişim gösterdin}.",
          "u": [
            "term",
            "special"
          ]
        },
        {
          "t": "{○○ adlı öğrencimizin olumlu yaklaşımı|Olumlu yaklaşımın} tüm sınıfın iyi öğrenmesine yardımcı oluyor.",
          "u": [
            "term",
            "brief"
          ]
        },
        {
          "t": "{○○ adlı öğrencimizin özgüveninin|Özgüveninin} her hafta arttığını görmekten büyük keyif aldım.",
          "u": [
            "term",
            "special"
          ],
          "tone": "warm"
        },
        {
          "t": "{○○ adlı öğrencimizin öğrenmeye karşı tutumu|Öğrenmeye karşı tutumun} istikrarlı ve olumluydu.",
          "u": [
            "term",
            "special"
          ],
          "tone": "formal"
        },
        {
          "t": "Küçük ve istikrarlı adımlar, {○○ için|senin için} gerçek bir ilerlemeye dönüşüyor.",
          "u": [
            "special"
          ],
          "f": "support"
        },
        {
          "t": "Her hafta pratik yapmak için yeni fırsatlar getiriyor ve {○○ bunları|bunları} çok iyi {değerlendiriyor|değerlendiriyorsun}.",
          "u": [
            "special"
          ],
          "f": "support"
        },
        {
          "t": "Bu dönemki gelişim, istikrarlı çabanın neler başarabileceğini gösteriyor.",
          "u": [
            "special"
          ],
          "f": "progress"
        },
        {
          "t": "{○○,|Sen,} {subj} dersinde yönergeleri iyi takip {ediyor|ediyorsun} ve özenle {çalışıyor|çalışıyorsun}.",
          "u": [
            "subject"
          ]
        },
        {
          "t": "{○○,|Sen,} {subj} dersinde iyi öğrenme alışkanlıkları {geliştiriyor|geliştiriyorsun}.",
          "u": [
            "subject"
          ]
        },
        {
          "t": "Bu dönem {subj} dersinde {○○ adlı öğrencimizin çalışmaları|çalışmaların} istikrarlı bir çabayı yansıtıyor.",
          "u": [
            "subject"
          ]
        },
        {
          "t": "Genel olarak, {subj} dersinde gösterilen çaba istikrarlıydı.",
          "u": [
            "subject"
          ],
          "tone": "formal"
        },
        {
          "t": "Attığın her küçük adım gerçekten çok değerli.",
          "u": [
            "cheer"
          ],
          "p": "child"
        },
        {
          "t": "Sıkı çalışman gerçek bir fark yaratıyor.",
          "u": [
            "cheer"
          ],
          "p": "child"
        },
        {
          "t": "○○ adlı öğrencimizin çabası gözden kaçmadı.",
          "u": [
            "cheer",
            "brief"
          ],
          "p": "parent"
        }
      ],
      "closings": [
        {
          "t": "Böyle harika çalışmaya devam!",
          "u": [
            "term",
            "brief",
            "cheer",
            "special"
          ],
          "tone": "warm"
        },
        {
          "t": "Böyle güzel çalışmaya devam.",
          "u": [
            "term",
            "brief",
            "subject",
            "special"
          ],
          "tone": "formal"
        },
        {
          "t": "Gelecek dönem {○○ adlı öğrencimizin parlamaya|parlamaya} devam ettiğini görmeyi sabırsızlıkla bekliyorum.",
          "u": [
            "term"
          ],
          "tone": "warm"
        },
        {
          "t": "{○○ adlı öğrencimizin önümüzdeki dönemi|Önümüzdeki dönemi} daha da güçlü geçireceğine eminim.",
          "u": [
            "term",
            "special"
          ]
        },
        {
          "t": "Bir sonraki aşamada {○○ adlı öğrencimize|sana} başarılar diliyorum.",
          "u": [
            "term"
          ],
          "g": [
            "high"
          ]
        },
        {
          "t": "Böyle devam!",
          "u": [
            "brief",
            "cheer",
            "subject"
          ]
        },
        {
          "t": "Seninle gurur duyuyorum!",
          "u": [
            "cheer",
            "special"
          ],
          "p": "child",
          "tone": "warm"
        },
        {
          "t": "Parlamaya devam et!",
          "u": [
            "cheer"
          ],
          "p": "child"
        },
        {
          "t": "Birlikte bu hedeflere doğru çalışmaya devam edeceğiz.",
          "u": [
            "special"
          ],
          "f": "support"
        },
        {
          "t": "Bu dönem yapılan güzel çalışmalar için tebrikler.",
          "u": [
            "subject",
            "term"
          ],
          "tone": "formal"
        },
        {
          "t": "{○○ adlı öğrencimizin gelecek dönem başaracağı|Gelecek dönem başaracağın} her şeyi görmeyi sabırsızlıkla bekliyorum.",
          "u": [
            "term"
          ]
        },
        {
          "t": "Önümüzde bir harika dönem daha olsun!",
          "u": [
            "term"
          ],
          "tone": "warm"
        },
        {
          "t": "{○○ adlı öğrencimize dinlendirici bir tatil|Dinlendirici bir tatil} ve gelecek döneme güçlü bir başlangıç diliyorum.",
          "u": [
            "term"
          ]
        },
        {
          "t": "{○○ bu dönemin|Bu dönemin} başarılarıyla gurur {duymalı|duymalısın}.",
          "u": [
            "term"
          ]
        },
        {
          "t": "Bu dönem ○○ adlı öğrencimize öğretmenlik yapmak bir ayrıcalıktı.",
          "u": [
            "term"
          ],
          "p": "parent"
        },
        {
          "t": "Bu dönemki tüm sıkı çalışmaların için teşekkür ederim.",
          "u": [
            "term"
          ],
          "p": "child"
        },
        {
          "t": "○○ adlı öğrencimizin gelişimi hakkında sizi bilgilendirmeye devam edeceğim.",
          "u": [
            "brief"
          ],
          "p": "parent"
        },
        {
          "t": "Harika şeyler oluyor, bu yüzden devam et!",
          "u": [
            "brief",
            "cheer"
          ],
          "tone": "warm"
        },
        {
          "t": "Böylesine istikrarlı bir çaba {○○ adlı öğrencimizi|seni} çok ileriye taşıyacaktır.",
          "u": [
            "brief",
            "cheer",
            "special"
          ]
        },
        {
          "t": "{○○ doğru yolda ilerliyor.|Doğru yoldasın.}",
          "u": [
            "brief",
            "subject",
            "special"
          ]
        },
        {
          "t": "{subj} dersinde daha fazla ilerleme görmeyi sabırsızlıkla bekliyorum.",
          "u": [
            "subject"
          ]
        },
        {
          "t": "Düzenli pratik yapmak bu güçlü yönleri daha da geliştirecektir.",
          "u": [
            "subject",
            "special"
          ]
        },
        {
          "t": "Aferin, böyle devam et.",
          "u": [
            "cheer",
            "brief"
          ]
        },
        {
          "t": "Bunu başarabilirsin!",
          "u": [
            "cheer"
          ],
          "p": "child"
        },
        {
          "t": "İleriye doğru atılan her adım değerlidir ve daha atılacak pek çok adım var.",
          "u": [
            "special"
          ],
          "f": "support"
        }
      ]
    },
    "elaborations": {
      "area": [
        "Bu durum, {subj} alanında sağlam bir temeli yansıtıyor.",
        "{○○ adlı öğrencimizin|Senin} {subj} dersindeki {ilerlemesi|ilerlemen} umut verici.",
        "Genel olarak, {subj} dersindeki çalışmalar sağlam.",
        "{○○ adlı öğrencimizin|Senin} {subj} dersindeki {çalışmalarının|çalışmalarının} kalitesi gerçek bir özeni yansıtıyor.",
        "Bu, {subj} dersindeki bir sonraki öğrenme aşaması için güçlü bir temel oluşturuyor.",
        "{○○,|Sen,} {subj} dersindeki bir sonraki adımlar için oldukça {hazır|hazırsın}.",
        "{subj} dersinde bu gelişimi görmek çok sevindirici."
      ],
      "learning": [
        "Öğrenmeye yönelik bu yaklaşım, tüm derslerde {○○ için|senin için} güçlü bir temel oluşturdu.",
        "Bu alışkanlıklar önümüzdeki yıllarda {○○ için|senin için} çok faydalı olacak.",
        "Bunun sonucunda {○○ çalışmalarında istikrarlı bir başarı sergiledi|çalışmalarında istikrarlı bir başarı sergiledin}.",
        "{○○ kalıcı|Kalıcı} başarıya götüren alışkanlıklar {ediniyor|ediniyorsun}.",
        "Bu istikrarlı yaklaşım, {○○ tarafından yapılan|yaptığın} günlük çalışmaların kalitesine de yansıyor.",
        "Böyle olumlu bir tutum, {○○ ile|seninle} ders işlemeyi çok keyifli hale getiriyor.",
        "Bu güçlü yönler, {○○ adlı öğrencimizin her dersten en iyi şekilde yararlanmasına|her dersten en iyi şekilde yararlanmana} yardımcı oluyor."
      ],
      "character": [
        "Bu nitelikler notlardan bile daha değerlidir.",
        "{○○ hem|Hem} sınıf arkadaşlarının hem de öğretmenlerinin saygısını {kazandı|kazandın}.",
        "Her gün böyle güzel bir karakter sergilediğini görmek büyük bir mutluluk.",
        "Sınıf arkadaşları {○○ adlı öğrencimize|sana} her zaman güvenebileceklerini biliyor.",
        "{○○ sakin|Sakin} ama etkili bir şekilde {davranışlarıyla çevresine örnek oluyor|davranışlarınla çevrene örnek oluyorsun}.",
        "Böyle bir karakter, duyarlı ve sevgi dolu bir sınıf ortamı oluşturmaya katkı sağlıyor.",
        "Bu gibi nitelikler, okul hayatının çok ötesinde de {○○ için|senin için} çok yararlı olacak."
      ],
      "social": [
        "Sınıf arkadaşları {○○ ile|seninle} birlikte öğrenmekten ve oynamaktan büyük keyif alıyor.",
        "{○○ sınıfımızı|Sınıfımızı} sıcak ve samimi bir yer haline getirmeye {yardımcı oluyor|yardımcı oluyorsun}.",
        "Bu sosyal beceriler gerçekten çok değerli bir kazanım.",
        "{○○ grupta|Sen grupta} yer aldığında grup etkinlikleri çok daha uyumlu ilerliyor.",
        "Bu beceriler, sınıftaki herkesin kendini dahil hissetmesine yardımcı oluyor.",
        "Başkalarıyla uyum içinde çalışabilmek en değerli becerilerden biridir.",
        "{○○ çevresindekilerin|Çevrendekilerin} en iyi yönlerini ortaya {çıkarıyor|çıkarıyorsun}."
      ],
      "routine": [
        "Bu güzel alışkanlıklar öğrenmeyi daha verimli hale getiriyor.",
        "{○○ başkalarına|Başkalarına} olumlu bir örnek {oluyor|oluyorsun}.",
        "Günlük sorumlulukları iyi yönetmek, büyüme sürecinde önemli bir adımdır.",
        "Hazırlıklı ve düzenli olmak, öğrenmeye daha fazla zaman kalması demektir.",
        "Bu rutinler, {○○ için|senin için} her güne sakin ve dengeli bir başlangıç sağlıyor.",
        "Böyle güzel alışkanlıklar gerçek bir öz yönetim ve bağımsızlık kazandırır.",
        "{○○ küçük|Küçük} günlük alışkanlıkların büyük fark yarattığını {gösteriyor|gösteriyorsun}."
      ],
      "service": [
        "Yardımlaşmaya olan bu isteklilik sınıfımızı daha güzel bir yer yapıyor.",
        "{○○ tarafından verilen|Verdiğin} destek sayesinde sınıf rutinleri çok daha sorunsuz ilerliyor.",
        "Başkalarına yardım etmek için zaman ayırmak gurur duyulacak bir davranıştır.",
        "Bu şekilde yardıma koşmak gerçek bir olgunluk göstergesidir.",
        "{○○ bu|Bu} görevleri neşeyle yerine {getiriyor ve bu davranışı|getiriyorsun ve bu davranışın} çok takdir ediliyor.",
        "Sınıf ortamımız bu tür destekler sayesinde daha da güçleniyor.",
        "Bu görev ve yardımlaşma bilinci çok değerli bir özelliktir."
      ],
      "talent": [
        "{○○ adlı öğrencimizin bu yeteneğini geliştirmeye devam etmesini|Bu yeteneğini geliştirmeye devam etmeni} diliyorum.",
        "Bu yetenek sınıf etkinliklerimize büyük bir zenginlik katıyor.",
        "Bu yeteneğin geliştiğini görmek heyecan verici.",
        "{○○ adlı öğrencimizin bu yeteneğini sınıfla paylaştığını|Bu yeteneğini sınıfla paylaştığını} görmek harika.",
        "{○○ bu yeteneğiyle|Bu yeteneğinle} gurur duymakta çok {haklı|haklısın}.",
        "Düzenli çalışmayla bu yetenek gelişmeye devam edecektir.",
        "Bu güçlü yön, {○○ için|senin için} özel bir şekilde parlama fırsatı sunuyor."
      ],
      "progress": [
        "Bu ilerleme kolay kazanılmadı ve kesinlikle takdir edilmeyi hak ediyor.",
        "{○○ adlı öğrencimizin çok sıkı çalıştığı|Çok sıkı çalıştığın} açıkça görülüyor.",
        "Bu değişimi görmekten gerçekten büyük mutluluk duyuyorum.",
        "Bu gelişim, düzenli çabanın neler başarabileceğini gösteriyor.",
        "{○○ çok|Çok} yol {katetti|katettin} ve bu kutlanmaya değer bir başarı.",
        "Atılan her küçük adım birleşerek gerçek bir değişime dönüştü.",
        "Bu ilerleme, önümüzdeki aylar için harika bir temel oluşturuyor."
      ]
    },
    "compact": [
      {
        "t": "{○○ şu|Şu} alanlar dahil pek çok güçlü yön {sergiledi|sergiledin}: {L}."
      },
      {
        "t": "Öne çıkan güçlü yönler: {L}."
      },
      {
        "t": "{○○ için|Senin için} öne çıkan güçlü yönler: {L}."
      },
      {
        "t": "{○○ özellikle şu yönleriyle öne çıkıyor|Özellikle şu yönlerinle öne çıkıyorsun}: {L}."
      },
      {
        "t": "{○○ için güçlü yönler|Senin güçlü yönlerin} arasında şunlar yer alıyor: {L}."
      },
      {
        "t": "Bu dönem öne çıkan başlıca güçlü yönler: {L}.",
        "tone": "formal"
      },
      {
        "t": "Dönem boyunca şu güzel özellikleri görmek büyük bir mutluluktu: {L}.",
        "tone": "warm",
        "u": [
          "term",
          "brief",
          "special"
        ]
      },
      {
        "t": "Özellikle şu olumlu yönleri vurgulamaktan mutluluk duyuyorum: {L}.",
        "tone": "formal"
      }
    ],
    "connectors": [
      "Buna ek olarak, ",
      "Ayrıca, ",
      "Bunun yanı sıra, "
    ],
    "wishLeads": [
      "",
      "",
      "Önümüzdeki süreçte, "
    ],
    "you": "sen",
    "possessive": "senin",
    "blankName": "[Ad]",
    "and": "ve",
    "unit": "kelime"
  },
  "roster": {
    "sheet": "Sınıf listesi",
    "guideSheet": "Yönergeler",
    "seat": "Öğrenci numarası",
    "name": "Öğrenci adı",
    "group": "Grup",
    "gender": "Cinsiyet",
    "avatar": "Avatar türü",
    "instructions": [
      "Yalnızca Sınıf listesi sayfasını, her satıra bir öğrenci gelecek şekilde doldurun.",
      "İlk satırdaki sütun başlıklarını koruyun. Yalnızca Öğrenci adı alanı zorunludur.",
      "Öğrenci numarası isteğe bağlıdır. Baştaki sıfırları korumak için 01 ve 02 gibi değerleri metin olarak biçimlendirin.",
      "Adlar en fazla 30 karakter olabilir ve sınıf içinde benzersiz olmalıdır. Tek seferde en fazla 100 öğrenci içe aktarabilirsiniz.",
      "İlk kurulum sırasında öğrenci içe aktarmak isteğe bağlıdır. Öğrencileri daha sonra Öğrenciler sayfasından da ekleyebilirsiniz.",
      ".xlsx, .xls, .ods veya UTF-8 CSV biçimini kullanın. CSV yalnızca tek bir sayfayı ve düz metni korur.",
      "Formül, makro, telefon numarası, e-posta adresi veya diğer gereksiz kişisel öğrenci verilerini eklemeyin.",
      "Sınıf listesi sayfası boştur. Bu kılavuz sayfası içe aktarılmaz."
    ],
    "male": "erkek",
    "female": "kız"
  },
  "demo": {
    "teacher": "Ayşe Öğretmen",
    "workspace": "ClassMori Örnek Sınıfı",
    "className": "3/A Sınıfı",
    "individualClassName": "3/B Bireysel Dostlar",
    "cycle": "1. Gelişim Dönemi",
    "pet": "Pamuk",
    "individualPet": "Örnek Dost",
    "groups": [
      "Kaşifler",
      "Yıldızlar",
      "Çınarlar",
      "Arılar"
    ],
    "names": [
      "Elif",
      "Zeynep",
      "Defne",
      "Asel",
      "Zümra",
      "Öykü",
      "Ecrin",
      "Nehir",
      "Miray",
      "Ada",
      "Gökçe",
      "Cemre",
      "Yusuf",
      "Alparslan",
      "Miraç",
      "Ömer",
      "Eymen",
      "Göktuğ",
      "Kerem",
      "Çınar",
      "Aras",
      "Kaan",
      "Emir",
      "Doruk"
    ],
    "surpriseItems": [
      [
        "Orman kapsülü",
        "🎁",
        6,
        "capsule",
        [
          [
            "Bir çıkartma seç",
            "🌈",
            "common"
          ],
          [
            "Öğretmen yardımcısı",
            "🤝",
            "common"
          ],
          [
            "Bir günlüğüne sıranı kendin seç",
            "🪑",
            "uncommon"
          ],
          [
            "Ödev muafiyeti kartı",
            "📝",
            "rare"
          ]
        ]
      ],
      [
        "Şanslı kazı kazan kartı",
        "🍀",
        6,
        "scratch",
        [
          [
            "Öğle arası müziğini seç",
            "🎵",
            "common"
          ],
          [
            "Bir günlüğüne bir arkadaşınla otur",
            "👫",
            "uncommon"
          ],
          [
            "Bir günlüğüne sınıf başkanı ol",
            "👑",
            "rare"
          ]
        ]
      ]
    ],
    "routines": [
      "Okuma",
      "Tartışma",
      "Toplanma"
    ]
  },
  "schema": {
    "home": "Ana sayfa",
    "freeTool": "ücretsiz araç",
    "product": {
      "description": "Öğretmenler için sınıf puanları ve sınıf evcil hayvanları: öğrencileri seçin, bir nedene dokunun ve her puanla evcil hayvanları büyüsün. Öğrenci hesabı gerekmez; 1 sınıf için sonsuza dek ücretsiz.",
      "free": "Ücretsiz plan",
      "yearly": "Plus planı, yıllık",
      "monthly": "Plus planı, aylık",
      "plus": "Pro planı, yıllık",
      "plusMonthly": "Pro planı, aylık"
    },
    "socialAlt": "ClassMori: orman sınıfında sınıf evcil hayvanlarıyla bir öğretmen ve öğrenciler"
  },
  "corePages": {
    "/": {
      "title": "ClassMori | Her öğrenci için bir evcil hayvan büyüten sınıf puanları",
      "description": "Öğretmenler için sınıf puanı ve sınıf evcil hayvanı uygulaması: öğrencileri seçin, bir nedene dokunun ve evcil hayvanlarının her puanla büyümesini izleyin. Her öğrenciye ayrı bir evcil hayvan ya da tüm sınıfa ortak bir evcil hayvan. Projeksiyonda veya telefonda çalışır, öğrenci hesabı gerekmez. 40 öğrenciye kadar 1 sınıf için ücretsiz."
    },
    "/about": {
      "title": "Hakkımızda | ClassMori",
      "description": "ClassMori ile tanışın: öğretmenlerin her çocuğun gelişimini görmesine yardımcı olan somut, olumlu geri bildirimler ve orman dostları."
    },
    "/pricing": {
      "title": "Fiyatlandırma | ClassMori",
      "description": "ClassMori, 40 öğrenciye kadar 1 sınıf için sonsuza dek ücretsizdir. Plus planı, 100'er öğrencili 5 sınıf için ayda 3 ABD doları ($3) veya yılda 19 ABD dolarıdır ($19; ilk yılınız 9,90 ABD doları / $9.90). Pro planı ve okul fiyat teklifleri de mevcuttur."
    },
    "/tour": {
      "title": "Öğretmen panelini deneyin | ClassMori",
      "description": "Kayıt olmanıza gerek yok: tüm sınıf için ortak bir evcil hayvanı ve her öğrenci için bireysel bir evcil hayvanı deneyin. Öğrencileri seçin, puan verin ve evcil hayvanların değişimini izleyin. Değişiklikler bu sayfada kalır ve sayfa yenilendiğinde sıfırlanır; tüm öğrenciler kurgusaldır."
    },
    "/privacy": {
      "title": "Gizlilik politikası | ClassMori",
      "description": "ClassMori'nin öğretmen hesaplarını ve sınıf verilerini nasıl işlediği ve verilerinizi nasıl talep edebileceğiniz."
    },
    "/terms": {
      "title": "Hizmet şartları | ClassMori",
      "description": "ClassMori hizmet şartları, hizmet kapsamı ve hesap kuralları."
    },
    "/contact": {
      "title": "Bize ulaşın | ClassMori",
      "description": "Sorularınız, önerileriniz veya okul satın alımı talebiniz mi var? ClassMori ekibiyle iletişime geçin."
    }
  },
  "scene": {
    "pets": {
      "otter": {
        "name": "Mori",
        "species": "su samuru",
        "foodName": "karides"
      },
      "rabbit": {
        "name": "Pofuduk",
        "species": "tavşan",
        "foodName": "havuç"
      },
      "penguin": {
        "name": "Ponçik",
        "species": "penguen",
        "foodName": "balık"
      }
    },
    "lines": {
      "calm": [
        "Buradayım. Acele etme, rahat ol.",
        "Küçük adımlar da kutlanmaya değer!",
        "Hazır mısın? Haydi birlikte başlayalım!",
        "Her adımda biraz daha ilerliyoruz.",
        "Derin bir nefes al. Yeni ve küçük bir görev seni bekliyor.",
        "Bugün keşfedilecek ne çok şey var!",
        "İşte sana birazcık cesaret!",
        "Fikirlerin paylaşılmaya değer!",
        "Bugünü birlikte sıcacık bir güne dönüştürelim.",
        "Seninle öğrenmeyi çok seviyorum!"
      ],
      "react": [
        "Çok naziksin, teşekkür ederim!",
        "Teşekkürler, içim sıcacık oldu.",
        "Hehe, arkadaş olduğumuza çok seviniyorum!",
        "Küçük bir dokunuş, kocaman bir sıcaklık.",
        "İşte senin için kocaman bir kalp!",
        "Sen buradayken bugün çok daha güzel.",
        "Güzel enerjimizi herkesle paylaşalım!",
        "Küçük bir güneş gibi sıcacıksın.",
        "Küçük iyilikler insanları mutlu eder!",
        "Küçük kalbim sana el sallıyor!"
      ],
      "wave": [
        "Merhaba! Bugün elimizden gelenin en iyisini yapalım!",
        "Seni görmek beni çok mutlu ediyor!",
        "El salla! Güzel enerjiler geliyor!",
        "Merhaba! Birlikte öğrenmeye hazır mısın?",
        "Yanındaki arkadaşına bir gülümseme gönder!",
        "Selamın küçük ormanı aydınlattı.",
        "Yakınındaki birine merhaba de!",
        "Nezaket insanın içini ısıtır.",
        "Küçük bir el sallama, biraz daha cesaret!",
        "Tüm arkadaşlarımız burada. Haydi başlayalım!"
      ],
      "eat": [
        "{food} için teşekkürler! Yavaş yavaş yiyeceğim.",
        "Arkadaşlarına ne kadar da güzel bakıyorsun.",
        "Küçük bir atıştırmalık, sonra devam edelim!",
        "Ham! Güzel enerji doğruca karnıma indi!",
        "Bana çok iyi bakıyorsun.",
        "Paylaştıkça mutluluk çoğalır!",
        "Bu {food} sevgi ve nezaket dolu.",
        "Karnım doydu, yeni bir göreve hazırım!",
        "Benimle ilgilenmeyi unutmadığın için teşekkürler.",
        "Karnım doydu! İşte senin için bir gülümseme!"
      ],
      "drink": [
        "Lıkır lıkır, bana iyi baktığın için teşekkürler!",
        "Bir yudum suyla enerjimiz yerine geldi!",
        "Sen de su içmeyi unutma!",
        "Küçük su damlaları güzel enerji getirir.",
        "Kendine iyi bakmak harika bir şey!",
        "Biraz mola ver, sonra devam et.",
        "Teşekkürler, bu yudum içimi ısıttı!",
        "Su molasını birlikte tamamladık!",
        "Vücudum iyi hissettiğinde daha iyi öğrenirim.",
        "Yenilendik ve yeni keşiflere hazırız!"
      ],
      "stretch": [
        "Biraz esneyelim, enerjimiz geri geliyor!",
        "Eller yukarı, güzel enerji buraya!",
        "Omuzlarını gevşet ve kendine moral ver.",
        "Küçük bir dinlenme daha ileri gitmemize yardımcı olur.",
        "Derin bir nefes al. Birlikte rahatlayalım.",
        "Baştan ayağa tamamen hazırız!",
        "Çok çalışıyorsun. Kendine de iyi bak.",
        "Esne ve gülümse!",
        "Küçük bir mola bir sonraki adıma güç verir.",
        "Çok daha iyi! Haydi birlikte tekrar deneyelim!"
      ],
      "celebrate": [
        "Harika iş! İşte senin için bir çaba yıldızı!",
        "Ne kadar özen gösterdiğini gördüm!",
        "İyi yapılan bir görev alkışı hak eder!",
        "Deneyecek kadar cesurdun. Harikasın!",
        "Bugün biraz daha ilerledik. Yaşasın!",
        "Bunu çok dikkatli yaptın. Süpersin!",
        "Seni yürekten kutluyorum. Parlamaya devam et!",
        "Her çaba fark edilmeyi hak eder!",
        "O kadar iyi yaptın ki sevinçten havalara uçuyorum!",
        "Yaşasın! İlerlemeni hep birlikte alkışlayalım!"
      ],
      "sleep": [
        "Enerjimi toplamak için kısa bir mola.",
        "Ahh… Küçük ormanda seninle birlikteyim.",
        "Sakin bir an kalbimi yumuşatıyor.",
        "Bugünkü başarıları tatlı rüyalara sarıyorum.",
        "Çok çalıştıktan sonra güzelce dinlen!",
        "İşte tatlı rüyalarla küçük ay geliyor.",
        "Gözlerini kapat ve kendine bir gülümseme sakla.",
        "Güzelce dinlendik. Haydi tekrar yola koyulalım.",
        "Bugün çok çaba gösterdiğin için teşekkürler!",
        "Gülümsemen tatlı rüyalarımda da yanımda."
      ],
      "jump": [
        "Bir, iki, üç, sevinçle zıpla!",
        "Sana mutluluk göndermek için küçük bir zıplayış!",
        "Küçük ayaklarım mutluluk dolu.",
        "Zıpla, cesaretin de biraz daha büyüsün!",
        "Mutluluğa el sallayalım!",
        "Yumuşak bir iniş, kocaman gülümsemeler!",
        "Neşeli küçük bir zıplayış. Haydi gidelim!",
        "Ormanda biraz daha kahkaha!",
        "Bugünün güzel enerjisini paylaş!",
        "Seninle oynamak çok eğlenceli!"
      ],
      "wake": [
        "Uyandım! Beni nazikçe uyandırdığın için teşekkürler.",
        "Yeni ve küçük bir görev. Haydi birlikte yapalım!",
        "Parlak gözler, harika bir enerji!",
        "Güzelce dinlendim. Yine enerji doluyum.",
        "Sabırla beklediğin için teşekkürler!",
        "Küçük bir esneme ve senin için bir gülümseme.",
        "Hazırım! Haydi bir adım ileri atalım!",
        "Güzel uyudum, cesaret doluyum!",
        "Sen buradayken uyanmak çok güzel.",
        "Küçük orman uyandı. Haydi başlayalım!"
      ],
      "read": [
        "Eğlenceli küçük bir kitap okuyorum.",
        "Bu sayfa ormandaki arkadaşları anlatıyor.",
        "Dur, bu sayfaya tekrar bakmak istiyorum.",
        "Bu hikâyeyi birlikte dinleyelim."
      ],
      "homework": [
        "Ödevimi yapıyorum. Neredeyse bitti!",
        "Yavaş yazmak da güzel yazmak demektir.",
        "Bunun üzerinde biraz daha düşüneyim.",
        "Bitti! Hepimiz daha iyiye gidiyoruz."
      ],
      "paint": [
        "Küçük bir çiçek çizip boyuyorum.",
        "Önce taç yapraklar, sonra yapraklar.",
        "En sevdiğin renk hangisi?",
        "Tamamdır! Bu senin için."
      ],
      "rope": [
        "İp atlıyorum. Ritmi yakala!",
        "Bir, iki, nazikçe zıpla.",
        "İp tam ayaklarımın altından geçti!",
        "Bir zıplayış daha. Çok eğlenceli!"
      ]
    }
  },
  "sceneUi": {
    "ClassMori · Forest pet scene": "ClassMori · Orman dostu sahnesi",
    "The forest pet's little forest": "Orman dostunun küçük ormanı",
    "Forest pet interactive scene": "Orman dostu etkileşimli sahnesi",
    "Your browser needs Canvas support to show the forest pet.": "Orman dostunu görüntülemek için tarayıcınızın Canvas desteği olmalıdır.",
    "Hi! Let's do our best today!": "Merhaba! Bugün elimizden gelenin en iyisini yapalım!",
    "A gentle pat. Your friend in the egg heard you!": "Nazik bir dokunuş. Yumurtadaki arkadaşın seni duydu!",
    "Knock, knock. We're waiting for you out here!": "Tık tık! Dışarıda seni bekliyoruz!",
    "Oh? A tiny sound from inside the egg!": "Aa? Yumurtanın içinden minik bir ses geldi!",
    "Something is moving in the den. Let's wait quietly.": "Yuvada bir şeyler kıpırdıyor. Sessizce bekleyelim.",
    "Pat the egg": "Yumurtayı okşa",
    "Knock gently": "Nazikçe tıklat",
    "Little wing": "Küçük kanat",
    "Pat to respond": "Tepki vermesi için okşa",
    " · Drag to pick up": " · Tutup kaldırmak için sürükle",
    ". Tap to get a reaction; drag to gently pick up.": ". Tepki almak için dokun; nazikçe kaldırmak için sürükle."
  },
  "languageSuggestion": {
    "region": "Dil",
    "available": "Bu sayfa dilinizde kullanılabilir",
    "view": "Bu sayfayı dilinizde görüntüleyin",
    "dismiss": "Kapat"
  },
  "heroAlt": "Kurgusal öğrenciler ve büyüyen evcil hayvanlarıyla ClassMori projeksiyon görünümü.",
  "sceneArrival": {
    "otter": {
      "waiting": "Hışır, hışır… Ağaç kovuğunda bir şey kıpırdıyor.",
      "peek": "{name} başını uzattı! Herkesle tanışmaya hazır.",
      "hello": "Merhaba! Sabırla beklediğiniz için çok teşekkür ederim."
    },
    "rabbit": {
      "waiting": "Yaprak perdesi kımıldıyor. {name} içeride dinleniyor.",
      "peek": "Uzun kulaklar göründü! {name} merhaba demek istiyor.",
      "hello": "Selam! Haydi birlikte sıkı çalışıp büyüyelim!"
    },
    "penguin": {
      "waiting": "Yumurta hafifçe sallandı. Yeni arkadaşın hazırlanıyor.",
      "peek": "Kabuk açıldı! {name} dünyaya göz atıyor.",
      "hello": "Cik! Beni desteklediğiniz için teşekkürler. İşte buradayım!"
    }
  },
  "sceneRegions": {
    "ear": "Sağ kulak",
    "earleft": "Sol kulak",
    "footleft": "Sol ayak",
    "footright": "Sağ ayak",
    "tail": "Kuyruk",
    "handleft": "Minik el",
    "wave": "Minik el",
    "wingleft": "Sol kanat",
    "wingright": "Sağ kanat",
    "tuft": "Baş perçemi",
    "face": "Yanaklar",
    "body": "Göbiş",
    "sleep": "Nazikçe uyandır"
  },
  "commentLanguageFaq": {
    "question": "Başka dillerde değerlendirme oluşturabilir miyim?",
    "answer": "Evet. Yeni ayarlar varsayılan olarak bu sayfanın dilini kullanır. Dil seçeneğinden Çince, İngilizce, İspanyolca, Fransızca, Brezilya Portekizcesi, Türkçe, Vietnamca veya Endonezce seçebilirsiniz. Değerlendirmelerde seçilen dildeki cümle havuzu kullanılır; isimler cihazınızda yerel olarak doldurulur."
  },
  "reasonAliases": {
    "Zamanında ödev teslimi": "homework",
    "Takım çalışması": "teamwork",
    "Derse odaklanma": "focus",
    "Görev tamamlandı": "persist",
    "Başkalarına yardım etme": "helpful",
    "Parmak kaldırma": "speak"
  }
}
